var Site = Site || {};
Site.Scripts = {
  Invoke: function(element, command, options) {
    options = options || {};
    if (command.length && Site.hasOwnProperty(command)) {
      Site[command].call([element], options);
    }
  },
  Run: function(command, options) {
    Site.Scripts.Invoke(document.body, command, options);
  },
  Init: function(element, options) {
    var root = element instanceof Element ? element : document.documentElement;
    var invokes = root.querySelectorAll("[data-script]");
    invokes.forEach(function(el) {
      var classes = el.dataset.script.split(" ");
      el.setAttribute("data-script-init", classes.join(" "));
      el.removeAttribute("data-script");
      classes.forEach(function(v) {
        Site.Scripts.Invoke(el, v, options);
      });
    });
  }
};
Site.Bootstrap = (function() {
  var go = function() {
    Site.$Doc = document;
    Site.$Body = document.body;
    Site.$HTML = document.documentElement;
    Site.Window = window;
    Site.$Window = window;
    document.body.classList.remove("disable-transition");
    var credit_css = "border: 1px solid black; color: black; background-color: white; font-size: 12px; line-height: 18px; padding: 12px 18px; margin-right: 8px; font-family: Courier, fixed; text-rendering: optimizeLegibility;;";
    console.log("%cBy FOR OFFICE USE ONLY", credit_css, "https://forofficeuseonly.com");
    Site.Init();
  };
  document.addEventListener("DOMContentLoaded", go);
})();
;
Site.Alert = function(message, button) {
  let content = '<div class="text__body-small block__sm">' + message + "</div>";
  if (button !== false) {
    content += '<a href="#" class="button" rel="modal:close">' + (button || "Ok") + "</a></div>";
  }
  Site.Events.trigger("modal:static", { content, size: "alert" });
};
Site.BreakpointConditional = function(comparator, breakpoint, on, off) {
  var active = false;
  var detect = function() {
    var now_active = void 0;
    switch (comparator) {
      case "eq":
      case "=":
        now_active = Site.Breakpoint.eq(breakpoint);
        break;
      case "lte":
      case "<=":
        now_active = Site.Breakpoint.lte(breakpoint);
        break;
      case "lt":
      case "<":
        now_active = Site.Breakpoint.lt(breakpoint);
        break;
      case "gte":
      case ">=":
        now_active = Site.Breakpoint.gte(breakpoint);
        break;
      case "gt":
      case ">":
        now_active = Site.Breakpoint.gt(breakpoint);
        break;
      default:
        Site.Debug('Site.BreakpointConditional: Invalid comparator "' + comparator + '"', "error");
        return false;
    }
    if (active === now_active) {
      return false;
    } else if (now_active === true) {
      if (typeof on === "function") on();
    } else if (now_active === false) {
      if (typeof off === "function") off();
    }
    active = now_active;
  };
  document.addEventListener("Site.Breakpoint:change", detect);
  detect();
  return {
    destroy: function() {
      document.removeEventListener("Site.Breakpoint:change", detect);
    },
    trigger: function() {
      detect();
    }
  };
};
;
Site.BreakpointHelper = function(options) {
  var current = null;
  var breakpoints = [];
  var resize_debounce = 250;
  var event_name = "Site.Breakpoint:change";
  var loadBreakpointSizes = function() {
    var root = getComputedStyle(document.documentElement);
    var css_var = function(name) {
      return parseFloat(root.getPropertyValue("--bp-" + name)) || 0;
    };
    return {
      "mobile": css_var("mobile"),
      "tablet": css_var("desktop") - 1,
      "desktop": css_var("desktop-lg") - 1,
      "desktop_lg": css_var("desktop-xl") - 1,
      "desktop_xl": 9999
    };
  };
  var detectSize = function() {
    var size = window.innerWidth;
    var previous = current;
    var sizes = breakpoints;
    current = Object.keys(sizes).find(function(key) {
      return sizes[key] > size;
    }) || Object.keys(sizes)[Object.keys(sizes).length - 1];
    if (current != previous) {
      document.dispatchEvent(new CustomEvent(event_name, { detail: current }));
    }
    return current;
  };
  Site.Breakpoint = {
    current: function() {
      return current;
    },
    eq: function(check) {
      return breakpoints[check] == breakpoints[current];
    },
    lt: function(check) {
      return breakpoints[current] < breakpoints[check];
    },
    lte: function(check) {
      return breakpoints[current] <= breakpoints[check];
    },
    gt: function(check) {
      return breakpoints[current] > breakpoints[check];
    },
    gte: function(check) {
      return breakpoints[current] >= breakpoints[check];
    },
    isMobile: function() {
      return Site.Breakpoint.eq("mobile");
    }
  };
  var _debounce = function(fn, wait) {
    var timer;
    return function() {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  };
  breakpoints = loadBreakpointSizes();
  window.addEventListener("resize", _debounce(detectSize, resize_debounce));
  detectSize();
};
;
Site.Console = function(...args) {
  var styles = {
    primary: "background:#111;color:#fff;padding:3px 8px;border-radius:4px;margin-right:6px;",
    error: "background:#b71c1c;color:#fff;padding:3px 8px;border-radius:4px;margin-right:6px;",
    info: "background:#ccc;color:#222;padding:3px 8px;border-radius:4px;margin-right:6px;",
    default: "border:1px solid #ccc;color:#222;padding:2px 7px;border-radius:4px;margin-right:6px;",
    text: "color:#222;margin-right:10px;"
  };
  var parts = [];
  var css = [];
  var logs = [];
  args.forEach(function(arg) {
    if (typeof arg === "string") {
      parts.push("%c" + arg);
      css.push(styles.default);
      return;
    }
    if (arg && typeof arg === "object" && !Array.isArray(arg)) {
      var keys = Object.keys(arg);
      var type = keys[0];
      if (keys.length === 1 && styles[type]) {
        parts.push("%c" + arg[type]);
        css.push(styles[type]);
        return;
      }
    }
    logs.push(arg);
  });
  if (parts.length) {
    window.console.log(parts.join(""), ...css, ...logs);
    return;
  }
  window.console.log(...logs);
};
window.c = Site.Console;
;
Site.DrawerAbstract = function(view, options) {
  var options = Object.assign({ name: "drawer", events: true }, options || {});
  var interactive = view.querySelector(".interactive");
  var name = view.getAttribute("drawer-name") || options.name;
  var open = false;
  var html_class = "--drawer-open";
  var open_class = "--open";
  var doOpen = function() {
    if (open) return;
    Site.Events.trigger("drawers:close");
    Site.Events.trigger("header:close");
    Site.Scrollbars.off();
    open = true;
    document.documentElement.classList.add(html_class);
    view.classList.add(open_class);
    interactive.focus({ preventScroll: true });
    setTimeout(() => {
      Site.PageLoaderLoading.done();
    }, 300);
  };
  var doClose = function() {
    if (!open) return;
    Site.Scrollbars.auto();
    open = false;
    document.documentElement.classList.remove(html_class);
    view.classList.remove(open_class);
  };
  var doToggle = function() {
    if (open) {
      doClose();
    } else {
      doOpen();
    }
  };
  var onClick = function(e) {
    var trigger = e.target.closest('[rel^="' + name + ':"]');
    if (!trigger) return;
    if (!trigger.matches('[rel="' + name + ':close"], [rel="' + name + ':open"], [rel="' + name + ':toggle"]')) return;
    e.preventDefault();
    var action = trigger.getAttribute("rel").split(":")[1];
    if (action === "close") {
      doClose();
    } else if (action === "open") {
      doOpen();
    } else if (action === "toggle") {
      doToggle();
    }
  };
  var onKey = function(e) {
    if (e.key !== "Escape") return;
    doClose();
  };
  this.__construct = function() {
    Site.Events.on("drawers:close", doClose);
    if (options.events) {
      document.addEventListener("keyup", onKey);
      document.addEventListener("click", onClick);
    }
    if (window.location.hash.replace("#", "") === name) {
      setTimeout(doOpen, 600);
    } else if (view.getAttribute("drawer-init") == "open") {
      doOpen();
    }
  };
  this.__destruct = function() {
    Site.Events.off("drawers:close", doClose);
    if (options.events) {
      document.removeEventListener("keyup", onKey);
      document.removeEventListener("click", onClick);
    }
  };
  this.__construct();
  return {
    open: doOpen,
    close: doClose,
    toggle: doToggle,
    destruct: this.__destruct,
    isOpen: function() {
      return open;
    }
  };
};
;
Site.Events = {
  events: [],
  on(event, callback) {
    document.addEventListener(event, callback);
    this.events.push({
      event,
      callback
    });
  },
  off(event, callback) {
    document.removeEventListener(event, callback);
    this.events = this.events.filter((item) => {
      return !(item.event === event && item.callback === callback);
    });
  },
  offAll(group) {
    this.events.forEach((item) => {
      if (item.event.startsWith(group)) {
        document.removeEventListener(item.event, item.callback);
      }
    });
    this.events = this.events.filter((item) => {
      return !item.event.startsWith(group);
    });
  },
  once(event, callback) {
    document.addEventListener(event, callback, { once: true });
  },
  trigger(event, detail = {}) {
    document.dispatchEvent(new CustomEvent(event, {
      detail
    }));
  }
};
;
Site.ExtendClass = function(instance) {
  var eventHook = function(method, event) {
    var local = method + event;
    if (instance.hasOwnProperty(local) && typeof instance[local] == "function") {
      Site.Events[method == "every" ? "on" : "once"]("page:" + event.toLowerCase(), instance[local]);
    }
  };
  eventHook("every", "Exit");
  eventHook("on", "Exit");
  eventHook("every", "Exited");
  eventHook("on", "Exited");
  eventHook("every", "Enter");
  eventHook("on", "Enter");
  eventHook("every", "Entered");
  eventHook("on", "Entered");
  if (typeof instance.__construct == "function") instance.__construct();
  if (typeof instance.__destruct == "function") Site.Events.once("page:exited", instance.__destruct);
};
;
Site.GoogleAnalytics = {
  debug: true,
  PageView: function() {
    if (window.Shopify && window.Shopify.analytics) {
      window.Shopify.analytics.publish("page_viewed", {});
    }
    if (typeof gtag === "function") {
      gtag("event", "page_view", {
        page_title: document.title,
        page_location: window.location.href
      });
      if (Site.GoogleAnalytics.debug) c({ primary: "GoogleAnalytics" }, { info: "PageView" }, { text: window.location.pathname }, { text: `"${document.title}"` });
    } else {
      if (Site.GoogleAnalytics.debug) c({ primary: "GoogleAnalytics" }, { error: "\u26A0\uFE0F Not Active" }, { info: "PageView" }, { text: location.pathname });
    }
  },
  Event: function(action, category, label, value) {
    if (Site.GoogleAnalytics.debug) c({ primary: "GoogleAnalytics" }, { info: "Event" }, { action, category, label });
    if (typeof gtag === "function") {
      gtag("event", action, {
        "event_category": category,
        "event_label": label,
        "value": value
      });
    } else if (typeof ga === "function") {
      ga("send", "event", action, category, label, value);
    } else {
      if (Site.GoogleAnalytics.debug) c({ primary: "GoogleAnalytics" }, { error: "\u26A0\uFE0F Not Active" });
    }
  }
};
;
Site.LazyLoad = new function() {
  var initialized = false;
  var onLazyLoaded = function(e) {
  };
  this.init = function() {
    window.lazySizesConfig = window.lazySizesConfig || {};
    lazySizesConfig.expFactor = 2;
    lazySizes.init();
    initialized = true;
  };
  this.refresh = function() {
    if (!initialized) this.init();
  };
  this.destroy = function() {
    initialized = false;
  };
}();
;
Site.ModalAbstract = function(view, options_incoming) {
  var options_default = Object.assign({
    allow_close: true,
    clear_on_close: true,
    show_loading: false,
    size: false
  }, options_incoming || {});
  var options = Object.assign({}, options_default);
  var modal_content = view.querySelector(".modal-content");
  var modal_window = view.querySelector(".window");
  var target = view.querySelector(".target");
  var open = false;
  var doOpenStart = function() {
    Site.Scrollbars.off();
    document.documentElement.classList.add("modal-open");
    if (options.show_loading) Site.PageLoaderLoading.start();
    addModalSize();
    modal_window.classList.add("--open", "--loading");
    view.classList.add("--active");
    open = true;
    return target;
  };
  var doOpenUpdate = function(content) {
    if (content instanceof Element) content = content.innerHTML;
    target.innerHTML = content.replace("data-modal-script", "data-script");
    setTimeout(function() {
      Site.Scripts.Init(target);
    }, 500);
    return true;
  };
  var doOpenComplete = function() {
    modal_window.classList.remove("--loading");
    Site.Events.trigger("modal:doing:close-complete");
    if (options.show_loading) Site.PageLoaderLoading.done();
    return target;
  };
  var doOpen = function(content) {
    doOpenStart();
    if (content) doOpenUpdate(content);
    doOpenComplete();
    return target;
  };
  var setOption = function(key, value) {
    options[key] = value;
  };
  var setSize = function(incoming) {
    if (incoming) setOption("size", incoming);
  };
  var addModalSize = function() {
    if (options.size) {
      if (typeof options.size == "number") {
        modal_window.style.maxWidth = options.size + "px";
      } else {
        modal_content.classList.add(options.size);
      }
    }
  };
  var removeModalSize = function() {
    if (options.size) {
      if (typeof options.size == "number") {
        modal_window.style.maxWidth = "";
      } else {
        modal_content.classList.remove(options.size);
      }
    }
  };
  var doClose = function(e) {
    if (e) e.preventDefault();
    if (!open) return false;
    if (!options.allow_close) return false;
    view.classList.add("--closing");
    Site.Scrollbars.auto();
    document.documentElement.classList.remove("modal-open");
    open = false;
    Site.Events.trigger("modal:doing:close");
    view.classList.remove("--active", "--closing");
    modal_window.classList.remove("--open");
    setTimeout(function() {
      removeModalSize();
      if (options.clear_on_close && target) target.innerHTML = "";
      options = Object.assign({}, options_default);
    }, 600);
    return true;
  };
  return {
    openStart: doOpenStart,
    openUpdate: doOpenUpdate,
    openComplete: doOpenComplete,
    open: doOpen,
    close: doClose,
    size: setSize,
    option: setOption,
    isOpen: function() {
      return open;
    }
  };
};
;
Site.ModalGdpr = function(param) {
  var view = this[0];
  var cookie_name = "ModalGdpr";
  var cookie_value = "gdpr1";
  var class_name = "--show";
  var open_delay = 1e3;
  var open = function() {
    c([{ type: "primary", text: "ModalGdpr" }, { text: "Open" }]);
    view.addEventListener("click", onClick);
    setTimeout(function() {
      view.classList.add(class_name);
    }, open_delay);
  };
  var close = function() {
    Site.CookieJar.write(cookie_name, cookie_value, 365);
    view.classList.remove(class_name);
  };
  var onClick = function(e) {
    if (e.target.closest('[rel="gdpr:close"]')) {
      e.preventDefault();
      close();
    }
  };
  this.everyEntered = function() {
    if (Site.Utils.getQueryParam("modal") == "gdpr") {
      open();
      open_delay = 300;
      return;
    }
    if (document.documentElement.classList.contains("shopify-previewmode") && window !== window.top) {
      return;
    }
    if (Site.CookieJar.read(cookie_name) == cookie_value) {
      return false;
    }
    open();
  };
  Site.ExtendClass(this, "persistent");
};
;
Site.Modal = function(param) {
  var view = this[0];
  var abstract = Site.ModalAbstract(view, { show_loading: true });
  var slug_active = false;
  var _openStart = function(trigger) {
    if (trigger && trigger.getAttribute("modal-size")) {
      abstract.option("size", trigger.getAttribute("modal-size"));
    }
    abstract.openStart();
    var slug = trigger && trigger.getAttribute("modal-slug");
    if (slug && slug.length) {
      slug_active = true;
      document.location.hash = slug;
    }
  };
  var _openComplete = function(html) {
    abstract.openUpdate(_loadArea(html));
    abstract.openComplete();
  };
  var doLoadAction = function(trigger) {
    _openStart(trigger);
    var path = trigger.getAttribute("href") !== "#" ? trigger.getAttribute("href") : trigger.dataset.href;
    fetch(path).then(function(r) {
      return r.text();
    }).then(_openComplete).catch(function(err) {
      alert("Error: " + err);
      doClose();
    });
  };
  var _loadArea = function(html) {
    try {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, "text/html");
      var main = doc.querySelector("main");
      if (main) return main.innerHTML;
    } catch (err) {
      return html;
    }
    return html;
  };
  var doElementAction = function(trigger) {
    var id = trigger.getAttribute("modal-element");
    var element = document.getElementById(id);
    if (!element) {
      console.error("ERROR: Modal element `#" + id + "` not found");
      return;
    }
    _openStart(trigger);
    _openComplete(element.innerHTML.replaceAll("modal-script", "script"));
  };
  var doStaticAction = function(detail) {
    if (detail.size != null) abstract.option("size", detail.size);
    if (detail.allowclose != null) abstract.option("allow_close", detail.allowclose);
    _openStart();
    _openComplete(detail.content);
  };
  var doSubmitAction = function(form) {
    _openStart(form);
    var url = form.getAttribute("action");
    var data = new FormData(form);
    fetch(url, { method: "POST", body: data }).then(function(r) {
      return r.text();
    }).then(_openComplete).catch(function(err) {
      alert("Error: " + err);
      doClose();
    });
  };
  var doClose = function(e, force) {
    if (e) e.preventDefault();
    if (force === true) abstract.option("allow_close", true);
    abstract.close();
    if (slug_active) {
      history.replaceState(null, null, " ");
      slug_active = false;
    }
    return false;
  };
  var onClick = function(e) {
    var load = e.target.closest('A[rel="modal:load"]');
    var element = e.target.closest('A[rel="modal:element"]');
    var close = e.target.closest('[rel="modal:close"]');
    var submit = e.target.closest('FORM[rel="modal:submit"]');
    if (close) {
      doClose(e);
    } else if (load) {
      e.preventDefault();
      if (load.getAttribute("modal-mobile") == "no" && Site.Breakpoints.eq("mobile")) return;
      doLoadAction(load);
    } else if (element) {
      e.preventDefault();
      doElementAction(element);
    }
  };
  var onSubmit = function(e) {
    var form = e.target.closest('FORM[rel="modal:submit"]');
    if (!form) return;
    e.preventDefault();
    doSubmitAction(form);
  };
  var onKey = function(e) {
    if (abstract.isOpen() && e.key === "Escape") doClose();
  };
  this.__construct = function() {
    document.addEventListener("click", onClick);
    document.addEventListener("submit", onSubmit);
    document.addEventListener("keyup", onKey);
    document.addEventListener("modal:element", function(e) {
      doElementAction(e.detail.trigger);
    });
    document.addEventListener("modal:static", function(e) {
      doStaticAction(e.detail);
    });
    document.addEventListener("modal:close", function(e) {
      doClose(e, e.detail && e.detail.force);
    });
    if (document.location.hash) {
      var slug = document.location.hash.replace("#", "");
      var trigger = document.querySelector('A[modal-slug="' + slug + '"]');
      if (trigger) {
        var rel = trigger.getAttribute("rel");
        if (rel === "modal:element") {
          doElementAction(trigger);
        } else {
          doLoadAction(trigger);
        }
      }
    }
  };
  this.everyEnter = function() {
    if (abstract.isOpen()) doClose();
  };
  Site.ExtendClass(this);
};
;
Site.PageLoaderAnchors = function() {
  var getAnchorFromHref = function(href) {
    try {
      var url = new URL(href, window.location.origin);
      return url.hash;
    } catch (e) {
      return null;
    }
  };
  var scrollToTarget = function(selector) {
    var target = document.querySelector(selector);
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };
  var waitForBarbaThenScroll = function(selector) {
    var handler = function() {
      setTimeout(function() {
        scrollToTarget(selector);
      }, 500);
      barba.hooks.after.unsubscribe(handler);
    };
    barba.hooks.after(handler);
  };
  var handleClick = function(e) {
    var link = e.target.closest('a[href*="#"]');
    if (!link) return;
    var href = link.getAttribute("href");
    if (!href || href === "#") return;
    if (href === "#main") return;
    var anchor = getAnchorFromHref(href);
    if (!anchor) return;
    var currentPath = window.location.pathname.replace(/\/$/, "");
    var hrefPath = href.replace(window.location.origin, "").split("#")[0].replace(/\/$/, "");
    var isSamePage = href.startsWith("#") || hrefPath === currentPath;
    if (isSamePage) {
      var target = document.querySelector(anchor);
      if (target) {
        e.preventDefault();
        scrollToTarget(anchor);
      }
    } else {
      waitForBarbaThenScroll(anchor);
    }
  };
  document.addEventListener("click", handleClick);
};
;
Site.PageLoaderHelpers = {
  refreshBodyClass: function(next) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(next.html, "text/html");
    document.body.className = doc.body.className;
  },
  refreshOutsideElements: function(htmlString, subview) {
    if (!Site.PageLoaderConfig.refresh_elements.hasOwnProperty(subview) || !Site.PageLoaderConfig.refresh_elements[subview].length) return;
    const parser = new DOMParser();
    const newDoc = parser.parseFromString(htmlString, "text/html");
    const elements = Site.PageLoaderConfig.refresh_elements[subview];
    elements.forEach((selector) => {
      const newEl = newDoc.querySelector(selector);
      const currentEl = document.querySelector(selector);
      if (newEl && currentEl) {
        currentEl.innerHTML = newEl.innerHTML;
      }
    });
  },
  executeInlineScripts: function(container, selector) {
    const scripts = container.querySelectorAll(`script[${selector}]`);
    scripts.forEach((script) => {
      const newScript = document.createElement("script");
      if (script.src) {
        newScript.src = script.src;
      } else {
        newScript.textContent = script.textContent;
      }
      Array.from(script.attributes).forEach((attr) => {
        newScript.setAttribute(attr.name, attr.value);
      });
      document.body.appendChild(newScript);
    });
  }
};
;
Site.PageLoaderLoading = {
  start: function() {
    Site.Events.trigger("page:loading:start");
    document.documentElement.classList.add("loader-existing");
    if (typeof NProgress == "object") NProgress.start();
  },
  done: function() {
    Site.Events.trigger("page:loading:end");
    document.documentElement.classList.remove("loader-existing");
    if (typeof NProgress == "object") NProgress.done();
  }
};
;
Site.PageLoaderSubview = function() {
  var Config = Site.PageLoaderConfig;
  var getTarget = function(name) {
    return document.querySelector('[data-subview="' + name + '"]');
  };
  var Transition = {
    fadeOut: function(el) {
      return new Promise(function(resolve) {
        el.style.transition = "opacity " + Config.fade_out_speed + "ms ease";
        el.style.opacity = 0;
        setTimeout(resolve, Config.fade_out_speed);
      });
    },
    fadeIn: function(el) {
      el.style.transition = "opacity " + Config.fade_in_speed + "ms ease";
      requestAnimationFrame(function() {
        el.style.opacity = 1;
      });
      setTimeout(function() {
        el.style.transition = "";
        el.style.opacity = "";
      }, Config.fade_in_speed);
    }
  };
  var load = function(url, name, scroll_to_top) {
    var target = getTarget(name);
    if (!target) return;
    Site.PageLoaderLoading.start();
    Site.Events.trigger("page:enter", { name, container: target });
    Transition.fadeOut(target).then(function() {
      return fetch(url).then(function(response) {
        return response.text();
      });
    }).then(function(html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var source = doc.querySelector('[data-subview="' + name + '"]');
      if (source) target.innerHTML = source.innerHTML;
      document.title = doc.title;
      history.pushState({}, "", url);
      Site.PageLoaderHelpers.refreshOutsideElements(html, name);
      Site.PageLoaderHelpers.executeInlineScripts(target, 'script-inline="allow"');
      Site.Scripts.Init(target, { subview: name });
      if (scroll_to_top) {
        Site.Events.trigger("header-sticky:listening", false);
        gsap.to(window, {
          scrollTo: { y: target },
          duration: 0.5,
          onComplete: () => {
            Site.Events.trigger("header-sticky:listening", true);
            loadComplete(name, target);
          }
        });
      } else {
        loadComplete(name, target);
      }
    });
  };
  var loadComplete = function(name, target) {
    Transition.fadeIn(target);
    Site.GoogleAnalytics.PageView();
    Site.PageLoaderLoading.done();
    Site.Events.trigger("page:entered", { name, container: target });
  };
  var onClick = function(e) {
    var link = e.target.closest("a[subview]");
    if (!link) return;
    e.preventDefault();
    load(link.getAttribute("href"), link.getAttribute("subview"), link.hasAttribute("subview-scroll"));
  };
  var onSubmit = function(e) {
    var form = e.target.closest("FORM[barba-form][subview]");
    if (!form) return;
    if (form.getAttribute("method") != "get") return;
    e.preventDefault();
    var action = form.getAttribute("action") || window.location.pathname;
    var params = new URLSearchParams(new FormData(form)).toString();
    var url = params ? action + "?" + params : action;
    load(url, form.getAttribute("subview"));
  };
  document.addEventListener("click", onClick);
  document.addEventListener("submit", onSubmit);
  Site.PageLoaderSubview.load = load;
};
;
Site.PageLoaderConfig = {
  refresh_elements: {},
  ignore_rules: [".no-barba"],
  fade_out_speed: 450,
  fade_in_speed: 800,
  // scroll_top_await    : 800,
  scroll_top_speed: 0,
  restore_scroll: true,
  anchors: true,
  subviews: true
};
Site.PageLoader = function(incoming_config) {
  Object.assign(Site.PageLoaderConfig, incoming_config);
  var Config = Site.PageLoaderConfig;
  var Transition = {
    scrollToTopSnap: function(duration) {
      if (duration == 0) {
        window.scrollTo({ top: 0 });
      }
    },
    scrollToTopAnimated: function(duration = 1500) {
      if (duration == 0) {
        return true;
      }
      const start = window.scrollY;
      const startTime = performance.now();
      function animateScroll(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        window.scrollTo(0, start * (1 - easeOutCubic(progress)));
        if (progress < 1) requestAnimationFrame(animateScroll);
      }
      function easeOutCubic(t) {
        return 1 - Math.pow(1 - t, 3);
      }
      requestAnimationFrame(animateScroll);
    },
    getContainer: function() {
      return document.querySelector(`[data-barba="wrapper"]`);
    },
    fadeOut: function() {
      const container = Transition.getContainer();
      return new Promise((resolve) => {
        container.style.transition = `opacity ${Config.fade_out_speed}ms ease`;
        container.style.opacity = 0;
        setTimeout(resolve, Config.fade_out_speed);
      });
    },
    fadeIn: function() {
      const container = Transition.getContainer();
      container.style.opacity = 0;
      container.style.transition = `opacity ${Config.fade_in_speed}ms ease`;
      requestAnimationFrame(() => {
        container.style.opacity = 1;
      });
      setTimeout(() => {
        container.style.opacity = "";
        container.style.transition = "";
      }, Config.fade_in_speed);
    }
  };
  var onFormSubmit = function(e) {
    const form = e.target.closest("FORM[barba-form]");
    if (!form) return;
    if (form.hasAttribute("subview")) return;
    if (form.getAttribute("method") != "get") return;
    e.preventDefault();
    Site.PageLoaderLoading.start();
    const action = form.getAttribute("action") || window.location.pathname;
    const params = new URLSearchParams(new FormData(form)).toString();
    barba.go(action + "?" + params, e.target);
  };
  var init = (function() {
    barba.init({
      prevent: ({ el }) => {
        const link = el.closest("a");
        if (Config.subviews && link.matches("[subview]")) return true;
        if (/.pdf/.test(link.href.toLowerCase())) return true;
        for (const rule of Config.ignore_rules) {
          if (link.matches(rule)) return true;
        }
        return false;
      },
      transitions: [{
        name: "fade",
        beforeLeave() {
          Transition.scrollToTopAnimated(Config.scroll_top_speed);
        },
        async leave(data) {
          await Transition.fadeOut();
        },
        beforeEnter(data) {
          Site.PageLoaderHelpers.refreshBodyClass(data.next);
        },
        enter(data) {
          Transition.scrollToTopSnap(Config.scroll_top_speed);
          Transition.fadeIn();
          Site.PageLoaderHelpers.executeInlineScripts(data.next.container, 'script-inline="allow"');
          Site.PageLoaderHelpers.executeInlineScripts(data.next.container, "data-cfasync");
          Site.PageLoaderHelpers.refreshOutsideElements(data.next.html, "default");
        }
      }]
    });
    if (Config.anchors) {
      Site.PageLoaderAnchors();
    }
    if (Config.subviews) {
      Site.PageLoaderSubview();
    }
    if (Config.restore_scroll) {
      history.scrollRestoration = "manual";
      var ScrollHistory = {
        history: {},
        is_back: false
      };
      window.addEventListener("popstate", () => {
        ScrollHistory.is_back = true;
      });
      barba.hooks.beforeLeave(({ current }) => {
        ScrollHistory.history[current.url.path] = window.scrollY;
      });
      barba.hooks.afterEnter(({ next }) => {
        if (ScrollHistory.is_back) {
          const savedY = ScrollHistory.history[next.url.path] || 0;
          setTimeout(function() {
            window.scrollTo(0, savedY);
          }, 100);
          ScrollHistory.is_back = false;
        }
      });
    }
    document.addEventListener("submit", onFormSubmit);
    barba.hooks.before(() => {
      Site.PageLoaderLoading.start();
    });
    barba.hooks.beforeLeave(() => {
      Site.Events.trigger("page:exit");
    });
    barba.hooks.afterLeave(() => {
      Site.Events.trigger("page:exited");
    });
    barba.hooks.enter((data) => {
      Site.Events.trigger("page:enter", { firstload: false, container: data.next.container, subview: null, data: data.next });
    });
    barba.hooks.after(() => {
      Site.Events.trigger("page:entered", { firstload: false, subview: null });
      Site.GoogleAnalytics.PageView();
      Site.PageLoaderLoading.done();
    });
    document.addEventListener("go", function(e) {
      if (e.detail && e.detail.view) {
        Site.PageLoaderSubview.load(e.detail.url, e.detail.view);
        return;
      }
      Site.PageLoaderLoading.start();
      barba.go(e.detail.url);
    });
    Site.Events.trigger("page:enter", { container: false, firstload: true, subview: null });
    Site.Events.trigger("page:entered", { firstload: true, subview: null });
  })();
};
;
Site.Scrollbars = {
  off: function() {
    document.documentElement.classList.add("no-scroll");
  },
  on: function() {
    document.documentElement.classList.remove("no-scroll");
  },
  auto: function() {
    Site.Scrollbars.on();
  }
};
;
function __return_false() {
  return false;
}
Site.Debug = function(message, extra) {
  if (typeof console != "object") return false;
  var args = Array.prototype.slice.call(arguments);
  console.log.apply(console, args);
};
Site.Utils = {
  getQueryParam: function(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"), results = regex.exec(location.search);
    return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  },
  decodeHtmlEntity: function(str) {
    return str.replace(/&#(\d+);/g, function(match, dec) {
      return String.fromCharCode(dec);
    });
  },
  encodeHtmlEntity: function(str) {
    var buf = [];
    for (var i = str.length - 1; i >= 0; i--) {
      buf.unshift(["&#", str[i].charCodeAt(), ";"].join(""));
    }
    return buf.join("");
  },
  shuffle: function(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;
    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
    return array;
  },
  range: function(start, count) {
    return Array.apply(0, Array(count)).map(function(element, index) {
      return index + start;
    });
  },
  jsonp: function(form, callback_param) {
    callback_param = callback_param || "callback";
    return new Promise(function(resolve, reject) {
      var callback_name = "JSONP" + Date.now() + Math.floor(Math.random() * 1e6);
      var action = new URL(form.getAttribute("action"), window.location.origin);
      var params = new URLSearchParams(action.search);
      new FormData(form).forEach(function(value, key) {
        params.set(key, value);
      });
      params.set(callback_param, callback_name);
      var script = document.createElement("script");
      var cleanup = function() {
        delete window[callback_name];
        script.remove();
      };
      window[callback_name] = function(response) {
        cleanup();
        resolve(response);
      };
      script.onerror = function() {
        cleanup();
        reject(new Error("JSONP request failed"));
      };
      script.src = action.origin + action.pathname + "?" + params.toString();
      script.async = true;
      document.body.appendChild(script);
    });
  }
};
;
Site.Init = function() {
  var title_announcer = document.getElementById("title-announcer");
  this.everyExit = function() {
  };
  this.everyEnter = function(e) {
    var params = e.detail || {};
    Site.PageLoaderLoading.done();
    Site.Scripts.Init(params.container, params);
    Site.LazyLoad.refresh();
  };
  this.everyEntered = function(e) {
  };
  this.__construct = function() {
    Site.Scripts.Run("BreakpointHelper");
    Site.Scripts.Run("Accessibility");
    Site.PageLoader({
      anchors: false,
      ignore_rules: [".no-barba", 'A[href$=".pdf"]', '[rel^="video:"]', '[rel^="modal:"]'],
      refresh_elements: {
        default: ["HEADER.sub"],
        products: [".collection__filter-navigation"]
      }
    });
    document.addEventListener("contextmenu", (event) => {
      if (event.target.closest("img")) {
        event.preventDefault();
      }
    });
  };
  Site.ExtendClass(this, "persistent");
};
;
Site.Accessibility = function() {
  var title_announcer = document.getElementById("title-announcer");
  this.everyExit = function() {
  };
  this.everyEnter = function(e) {
  };
  this.everyEntered = function(e) {
    var params = e.detail || {};
    if (params.firstload) return;
    title_announcer.textContent = "";
    requestAnimationFrame(function() {
      title_announcer.textContent = document.title;
    });
    const main = document.getElementById("main");
    if (main) {
      main.setAttribute("tabindex", "-1");
      main.focus({ preventScroll: true });
    }
  };
  this.__construct = function() {
  };
  Site.ExtendClass(this);
};
;
Site.Accordion = function(param) {
  var view = this[0];
  var animation = 0.4;
  var multiple = view.getAttribute("accordion-multiple") === "true";
  var open_first = view.getAttribute("accordion-openfirst") === "true";
  var animatePanel = function(panel, open, onComplete) {
    gsap.to(panel, {
      height: open ? "auto" : 0,
      opacity: open ? 1 : 0,
      duration: animation,
      ease: "power2.inOut",
      onComplete
    });
  };
  var closeItem = function(item) {
    var trigger = item.querySelector(".trigger");
    var panel = item.querySelector(".panel");
    item.classList.remove("--open");
    if (trigger) trigger.setAttribute("aria-expanded", "false");
    animatePanel(panel, false, function() {
      if (panel) panel.setAttribute("aria-hidden", "true");
      Site.Events.trigger("accordion:update");
    });
  };
  var onClick = function(e) {
    var trigger = e.target.closest(".trigger");
    if (!trigger) return;
    var item = trigger.closest(".item");
    var panel = item.querySelector(".panel");
    var open = trigger.getAttribute("aria-expanded") === "true";
    if (!multiple && !open) {
      view.querySelectorAll(".item.--open").forEach(closeItem);
    }
    item.classList.toggle("--open", !open);
    trigger.setAttribute("aria-expanded", !open);
    if (!open) panel.setAttribute("aria-hidden", "false");
    animatePanel(panel, !open, function() {
      if (open) panel.setAttribute("aria-hidden", "true");
      Site.Events.trigger("accordion:update");
    });
  };
  this.__construct = function() {
    view.querySelectorAll(".trigger").forEach(function(trigger) {
      if (!trigger.hasAttribute("aria-expanded")) {
        trigger.setAttribute("aria-expanded", "false");
      }
    });
    view.addEventListener("click", onClick);
    if (open_first) {
      var first = view.querySelector(".item");
      if (first) first.querySelector(".trigger").click();
    }
  };
  this.__destruct = function() {
    view.removeEventListener("click", onClick);
  };
  Site.ExtendClass(this);
};
;
Site.CarouselScrollMobile = function(param) {
  var view = this[0];
  var carousel = null;
  var breakpoint = null;
  var turnOn = function() {
    if (carousel) return;
    view.classList.add("carousel__scroll");
    carousel = [view];
    Site.CarouselScroll.call(carousel);
  };
  var turnOff = function() {
    if (!carousel) return;
    carousel.__destruct();
    carousel = null;
    view.classList.remove("carousel__scroll");
  };
  this.__construct = function() {
    breakpoint = new Site.BreakpointConditional("eq", "mobile", turnOn, turnOff);
  };
  this.__destruct = function() {
    if (breakpoint) breakpoint.destroy();
    turnOff();
  };
  Site.ExtendClass(this);
};
;
Site.CarouselScroll = function(param) {
  var view = this[0];
  var track = view.querySelector(".track");
  var slides = view.querySelectorAll(".cell");
  var arrows = view.querySelectorAll(".arrows .arrow");
  var autoplay_enabled = view.getAttribute("carousel-autoplay") == "true";
  var autoplay_time = 4e3;
  var Autoplay = {
    enabled: false,
    observer: false,
    threshold: 0.05,
    timer: false,
    playing: false,
    play: function() {
      if (Autoplay.playing) return;
      Autoplay.playing = true;
      Autoplay.timer = setInterval(Navigation.next, autoplay_time);
    },
    pause: function() {
      if (!Autoplay.playing) return;
      clearInterval(Autoplay.timer);
      Autoplay.timer = null;
      Autoplay.playing = false;
    },
    on: function() {
      Autoplay.observer = new IntersectionObserver(([entry]) => {
        if (entry.intersectionRatio >= Autoplay.threshold) {
          Autoplay.play();
        } else if (entry.intersectionRatio === 0) {
          Autoplay.pause();
        }
      }, { threshold: [0, Autoplay.threshold] });
      Autoplay.observer.observe(view);
      Autoplay.enabled = true;
    },
    off: function() {
      if (!Autoplay.enabled) return;
      Autoplay.pause();
      if (Autoplay.observer) {
        Autoplay.observer.disconnect();
        Autoplay.observer = null;
      }
      Autoplay.enabled = false;
    }
  };
  var Navigation = {
    observer: false,
    tween: null,
    /*
            _getActive: function() {
    
                // return view.querySelector('.cell.--visible') || slides[0];
    
                var visibles = view.querySelectorAll('.cell.--visible');
                if (!visibles.length) return slides[0];
                if (visibles.length === 1) return visibles[0];
    
                var trackCenter = track.scrollLeft + track.clientWidth / 2;
                var closest = null;
                var minDistance = Infinity;
    
                visibles.forEach(slide => {
                    var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
                    var distance = Math.abs(slideCenter - trackCenter);
                    if (distance < minDistance) {
                        minDistance = distance;
                        closest = slide;
                    }
                });
    
                return closest || slides[0];
            },
            */
    _getActive: function(direction) {
      var visibles = Array.from(view.querySelectorAll(".cell.--visible"));
      if (!visibles.length) return slides[0];
      if (visibles.length === 1) return visibles[0];
      if (direction === "next") {
        return visibles[visibles.length - 1];
      } else if (direction === "prev") {
        return visibles[0];
      }
      var trackCenter = track.scrollLeft + track.clientWidth / 2;
      return visibles.reduce((closest, slide) => {
        var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        var distance = Math.abs(slideCenter - trackCenter);
        return distance < closest.distance ? { slide, distance } : closest;
      }, { slide: slides[0], distance: Infinity }).slide;
    },
    _scrollToSlide: function(slide) {
      Pager.setCurrentFromSlide(slide);
      if (Navigation.tween) Navigation.tween.kill();
      var wrap = getComputedStyle(track).getPropertyValue("scroll-padding-left").trim();
      var target = parseInt(slide.offsetLeft) - parseInt(wrap);
      Navigation.tween = gsap.to(track, {
        scrollTo: { x: target },
        duration: 0.9,
        ease: "power1.inOut",
        onStart: () => {
          view.classList.add("--moving");
          track.style.scrollSnapType = "none";
          track.style.scrollBehavior = "auto";
        },
        onComplete: () => {
          view.classList.remove("--moving");
          track.style.scrollSnapType = "x mandatory";
        }
      });
    },
    _focusSlide: function(e) {
      var cell = e.currentTarget.closest(".cell");
      if (e.currentTarget.matches(":focus-visible")) {
        Navigation._scrollToSlide(cell);
      }
    },
    _checkEdges: function() {
      var atStart = track.scrollLeft <= 0;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth;
      var overflowing = track.scrollWidth > track.clientWidth;
      view.classList.toggle("--at-start", atStart);
      view.classList.toggle("--at-end", atEnd);
      view.classList.toggle("--not-overflowing", !overflowing);
    },
    next: function() {
      var active = Navigation._getActive("next");
      var next = active.nextElementSibling || slides[0];
      Navigation._scrollToSlide(next);
    },
    prev: function() {
      var active = Navigation._getActive("prev");
      var prev = active.previousElementSibling || slides[slides.length - 1];
      Navigation._scrollToSlide(prev);
    },
    on: function() {
      Navigation.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle("--visible", entry.isIntersecting);
        });
      }, { root: track, threshold: 1 });
      slides.forEach((slide) => Navigation.observer.observe(slide));
      view.querySelectorAll(".cell a").forEach((link) => {
        link.addEventListener("focus", Navigation._focusSlide);
      });
      window.addEventListener("resize", Navigation._checkEdges);
      track.addEventListener("scroll", Navigation._checkEdges);
      Navigation._checkEdges();
    },
    off: function() {
      if (Navigation.observer) {
        slides.forEach((slide) => Navigation.observer.unobserve(slide));
        Navigation.observer.disconnect();
      }
      view.querySelectorAll(".cell a").forEach((link) => {
        link.removeEventListener("focus", Navigation._focusSlide);
      });
      window.removeEventListener("resize", Navigation._checkEdges);
      track.removeEventListener("scroll", Navigation._checkEdges);
    }
  };
  var clickArrow = function(e) {
    e.preventDefault();
    if (e.currentTarget.classList.contains("--next")) {
      Navigation.next();
    } else if (e.currentTarget.classList.contains("--prev")) {
      Navigation.prev();
    }
    Autoplay.off();
  };
  var clickCell = function(e) {
    if (!e.currentTarget.classList.contains("--visible")) {
      Navigation.next();
    }
    Autoplay.off();
  };
  var Looping = {
    width: 0,
    calculateWidth: function() {
      if (!slides.length) return 0;
      const first = slides[0];
      const last = slides[slides.length - 1];
      const rectFirst = first.getBoundingClientRect();
      const rectLast = last.getBoundingClientRect();
      Looping.width = rectLast.right - rectFirst.left;
      return Looping.width;
    },
    onScroll: function() {
      if (track.scrollLeft >= Looping.width) {
        track.style.scrollSnapType = "none";
        track.style.scrollBehavior = "auto";
        track.scrollLeft -= Looping.width;
        setTimeout(() => {
          track.style.scrollSnapType = "x mandatory";
        }, 900);
      }
    },
    on: function() {
      const clones = Array.from(slides).map((slide) => slide.cloneNode(true));
      clones.forEach((clone) => track.querySelector(".cells").appendChild(clone));
      Looping.calculateWidth(track, slides);
      window.addEventListener("resize", Looping.calculateWidth);
      track.addEventListener("scroll", Looping.onScroll);
    }
  };
  var Pager = {
    counter: view.querySelector(".counter"),
    pages: view.querySelector(".pages"),
    buttons: [],
    perpage: 1,
    totalpages: 1,
    current: 1,
    ticking: false,
    calculateValues: function() {
      Pager.perpage = Math.floor(track.clientWidth / slides[0].clientWidth);
      Pager.perpage = Math.max(Pager.perpage, 1);
      Pager.totalpages = Math.ceil(slides.length / Pager.perpage);
      Pager.buildDots();
      Pager.updateDisplay();
    },
    buildDots: function() {
      if (!Pager.pages) return;
      Pager.pages.innerHTML = "";
      Pager.buttons = [];
      for (var i = 0; i < Pager.totalpages; i++) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "page";
        button.setAttribute("aria-label", "Go to page " + (i + 1));
        button.addEventListener("click", /* @__PURE__ */ (function(page) {
          return function() {
            Pager.goToPage(page);
            Autoplay.off();
          };
        })(i + 1));
        Pager.pages.appendChild(button);
        Pager.buttons.push(button);
      }
      Pager.pages.style.setProperty("--totalpages", Pager.totalpages);
    },
    goToPage: function(page) {
      var index = (page - 1) * Pager.perpage;
      var slide = slides[index] || slides[slides.length - 1];
      Navigation._scrollToSlide(slide);
    },
    setCurrentFromSlide: function(slide) {
      var index = Array.prototype.indexOf.call(slides, slide);
      if (index === -1) return;
      Pager.current = Math.floor(index / Pager.perpage) + 1;
      Pager.updateDisplay();
    },
    updateDisplay: function() {
      if (Pager.counter) {
        Pager.counter.textContent = Pager.current + "/" + Pager.totalpages;
      }
      if (Pager.pages) {
        Pager.pages.style.setProperty("--current", Pager.current - 1);
      }
      Pager.buttons.forEach(function(button, i) {
        button.setAttribute("aria-current", i === Pager.current - 1 ? "true" : "false");
      });
    },
    setCurrent: function() {
      if (view.classList.contains("--moving")) return;
      var scrollpos = track.scrollLeft;
      var page = Math.round(scrollpos / track.clientWidth) + 1;
      Pager.current = Math.min(Math.max(page, 1), Pager.totalpages);
      Pager.updateDisplay();
    },
    _onScroll: function() {
      if (Pager.ticking) return;
      Pager.ticking = true;
      window.requestAnimationFrame(function() {
        Pager.setCurrent();
        Pager.ticking = false;
      });
    },
    on: function() {
      if (!Pager.counter && !Pager.pages) return;
      Pager.calculateValues();
      Pager.setCurrent();
      window.addEventListener("resize", Pager.calculateValues);
      track.addEventListener("scroll", Pager._onScroll);
    },
    off: function() {
      window.removeEventListener("resize", Pager.calculateValues);
      track.removeEventListener("scroll", Pager._onScroll);
    }
  };
  var UserInteraction = {
    startX: 0,
    startY: 0,
    hasScrolled: false,
    scrolledHorizontally: function() {
      UserInteraction.off();
      Autoplay.off();
    },
    wheel: function(e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 15) {
        UserInteraction.scrolledHorizontally();
      }
    },
    pointerMove: function(e) {
      if (!e.isPrimary || e.pointerType !== "touch" && e.pointerType !== "pen") return;
      if (Math.abs(e.movementX) > Math.abs(e.movementY) && Math.abs(e.movementX) > 5) {
        UserInteraction.scrolledHorizontally();
      }
    },
    touchStart: function(e) {
      UserInteraction.startX = e.touches[0].clientX;
      UserInteraction.startY = e.touches[0].clientY;
    },
    touchEnd: function(e) {
      var dx = e.changedTouches[0].clientX - UserInteraction.startX;
      var dy = e.changedTouches[0].clientY - UserInteraction.startY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
        UserInteraction.scrolledHorizontally();
      }
    },
    on: function() {
      track.addEventListener("wheel", UserInteraction.wheel, { passive: true });
      track.addEventListener("pointermove", UserInteraction.pointerMove, { passive: true });
      track.addEventListener("touchstart", UserInteraction.touchStart, { passive: true });
      track.addEventListener("touchend", UserInteraction.touchEnd, { passive: true });
    },
    off: function() {
      track.removeEventListener("wheel", UserInteraction.wheel);
      track.removeEventListener("pointermove", UserInteraction.pointerMove);
      track.removeEventListener("touchstart", UserInteraction.touchStart);
      track.removeEventListener("touchend", UserInteraction.touchEnd);
    }
  };
  this.__construct = function() {
    if (arrows.length) {
      arrows.forEach((arrow) => arrow.addEventListener("click", clickArrow));
    }
    UserInteraction.on();
    if (autoplay_enabled) Autoplay.on();
    Navigation.on();
    Pager.on();
  };
  this.__destruct = function() {
    if (arrows.length) {
      arrows.forEach((arrow) => arrow.removeEventListener("click", clickArrow));
    }
    Autoplay.off();
    UserInteraction.off();
    Navigation.off();
    Pager.off();
  };
  Site.ExtendClass(this);
};
;
Site.CartAddTo = function(param) {
  var form = this[0];
  var buttons = [
    form.querySelector('BUTTON[type="submit"]'),
    document.querySelector('[rel="product:atc"]')
  ].filter(Boolean);
  var add = function(e) {
    const sold_out = form.querySelector(".sold-out");
    if (sold_out && sold_out.offsetParent !== null) {
      c("ATC: Is sold out !");
      return false;
    }
    e.preventDefault();
    if (window.location.hostname === "127.0.0.1") {
      alert("Cannot add to cart locally");
      return;
    }
    Site.PageLoaderLoading.start();
    const form_data = new FormData(form);
    buttons.forEach(function(btn) {
      btn.classList.add("--loading");
      btn.disabled = true;
    });
    fetch("/cart/add.js", {
      method: "POST",
      body: form_data
    }).then(function(response) {
      if (!response.ok) throw new Error("Add to cart failed");
      return response.json();
    }).then(function(item) {
      Site.Events.trigger("drawer-cart:refresh", { open: true });
    }).catch(function(error) {
      alert("Unable to add to cart");
      console.error(error);
    }).finally(function() {
      buttons.forEach(function(btn) {
        btn.classList.remove("--loading");
        btn.disabled = false;
      });
    });
  };
  this.__construct = function() {
    form.addEventListener("submit", add);
  };
  this.__destruct = function() {
    form.removeEventListener("submit", add);
  };
  Site.ExtendClass(this);
};
;
Site.CartDiscount = function(param) {
  var view = this[0];
  var refresh_class = "--refreshing";
  var onSubmit = function(e) {
    var form = e.target.closest('[rel="cart:discount"]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('[name="discount"]');
    var code = input.value.trim();
    if (!code) return;
    view.classList.add(refresh_class);
    Site.PageLoaderLoading.start();
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ discount: code })
    }).then(function(r) {
      return r.json();
    }).then(function(cart) {
      c(cart);
      var applied = (cart.discount_codes || []).find(function(discount) {
        return discount.code.toLowerCase() === code.toLowerCase();
      });
      view.classList.remove(refresh_class);
      Site.PageLoaderLoading.done();
      if (applied && applied.applicable) {
        input.value = "";
        Site.Events.trigger("drawer-cart:refresh");
      } else {
        Site.Alert("The code you entered is not valid.");
      }
    });
  };
  var onForgotClick = function(e) {
    var trigger = e.target.closest('[rel="cart-discount:forgot"]');
    if (!trigger) return;
    e.preventDefault();
    Site.Events.trigger("modal:element", { trigger, allowclose: true });
  };
  var onForgotSubmit = function(e) {
    var form = e.target.closest('[rel="cart-discount:forgot-submit"]');
    if (!form) return;
    e.preventDefault();
    Site.PageLoaderLoading.start();
    Site.Utils.jsonp(form, "_jsonp").then(function(response) {
      Site.Alert(response.message);
    }).catch(function() {
      Site.Alert("Something went wrong. Please try again.");
    }).finally(function() {
      Site.PageLoaderLoading.done();
    });
  };
  this.__construct = function() {
    view.addEventListener("submit", onSubmit);
    view.addEventListener("click", onForgotClick);
    document.addEventListener("submit", onForgotSubmit);
  };
  Site.ExtendClass(this);
};
;
Site.Cart = function(param) {
  var view = this[0];
  var drawer = new Site.DrawerAbstract(view);
  var display = view.querySelector(".inside");
  var loading_class = "--loading";
  var refresh_class = "--refreshing";
  var updateCount = function(cart) {
    document.querySelectorAll("[cartcount]").forEach(function(count) {
      count.textContent = cart.item_count;
      count.classList.toggle("--empty", cart.item_count === 0);
    });
  };
  var fetchCartHTML = function() {
    return fetch("/cart?view=ajax").then(function(r) {
      return r.text();
    }).then(function(html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var main = doc.querySelector("MAIN.cart");
      return main ? main.innerHTML : "";
    });
  };
  var refreshCart = function(e) {
    let do_open = e?.detail?.open || false;
    view.classList.add(loading_class);
    return Promise.all([
      fetchCartHTML(),
      fetch("/cart.js").then(function(r) {
        return r.json();
      })
    ]).then(function(results) {
      var html = results[0];
      var cart = results[1];
      display.innerHTML = html;
      view.classList.remove(loading_class);
      if (do_open) {
        drawer.open();
      }
      Site.PageLoaderLoading.done();
      setTimeout(function() {
        updateCount(cart);
      }, 900);
      return cart;
    });
  };
  var onCartAction = function(e) {
    var minus = e.target.closest('[rel="cart:row:minus"]');
    var plus = e.target.closest('[rel="cart:row:plus"]');
    var remove = e.target.closest('[rel="cart:row:remove"]');
    if (!minus && !plus && !remove) return;
    e.preventDefault();
    view.classList.add(refresh_class);
    view.classList.add(loading_class);
    Site.PageLoaderLoading.start();
    var row = (minus || plus || remove).closest(".row");
    var key = row.dataset.key;
    var current = parseInt(row.querySelector(".cart-qty__value").textContent, 10);
    var new_qty = remove ? 0 : minus ? Math.max(0, current - 1) : current + 1;
    if (!remove) row.querySelector(".cart-qty__value").textContent = new_qty;
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: new_qty })
    }).then(function(r) {
      return r.json();
    }).then(function(cart) {
      return fetchCartHTML().then(function(html) {
        display.innerHTML = html;
        view.classList.remove(loading_class);
        view.classList.remove(refresh_class);
        Site.PageLoaderLoading.done();
        setTimeout(function() {
          updateCount(cart);
        }, 900);
      });
    });
  };
  this.__construct = function() {
    view.addEventListener("click", onCartAction);
    Site.Events.on("drawer-cart:refresh", refreshCart);
    if (!Shopify.designMode) setTimeout(refreshCart, 1e3);
  };
  this.everyExit = function() {
    drawer.close();
  };
  Site.ExtendClass(this);
};
;
Site.FooterAkari = function(param) {
  var view = this[0];
  var triggers = view.querySelectorAll('[rel="footer:akari-info"]');
  var breakpoint = null;
  var show = function() {
    view.classList.add("--show-info");
  };
  var hide = function() {
    view.classList.remove("--show-info");
  };
  var onClick = function(e) {
    e.preventDefault();
    view.classList.toggle("--show-info");
  };
  var activateMobile = function() {
    triggers.forEach(function(trigger) {
      trigger.removeEventListener("mouseenter", show);
      trigger.removeEventListener("mouseleave", hide);
      trigger.addEventListener("click", onClick);
    });
  };
  var activateDesktop = function() {
    triggers.forEach(function(trigger) {
      trigger.removeEventListener("click", onClick);
      trigger.addEventListener("mouseenter", show);
      trigger.addEventListener("mouseleave", hide);
    });
  };
  this.__construct = function() {
    breakpoint = new Site.BreakpointConditional("eq", "mobile", activateMobile, activateDesktop);
    if (Site.Breakpoint.gte("desktop")) activateDesktop();
  };
  Site.ExtendClass(this);
};
;
Site.FormRangeCheckboxes = function(param) {
  var view = this[0];
  var slider = view.querySelector(".slider");
  var checkboxes = view.querySelectorAll(".checkboxes INPUT");
  var cookie_name = "FormRangeFormat";
  var format_as = Site.CookieJar.read(cookie_name) || view.getAttribute("range-format-as") || "default";
  var tooltipFormatter = {
    // from: value => Number(String(value).replace('$', '')),
    to: function(value) {
      switch (format_as) {
        case "cm":
        case "centemeter":
        case "centemeters":
          return Math.round(value * 2.54) + " cm";
        case "in":
        case "inch":
        case "inches":
          return Math.round(value) + " in";
        case "ft":
        case "foot":
        case "feet":
          return Math.round(value) + " ft";
        case "money":
          return "$" + Math.round(value);
        default:
          return value;
      }
    }
  };
  var toggleCheckboxes = function(values) {
    let min = Math.round(values[0]);
    let max = Math.round(values[1]);
    let checked = 0;
    checkboxes.forEach(function(checkbox) {
      const value = parseInt(checkbox.value, 10);
      checkbox.checked = value >= min && value <= max;
      if (checkbox.checked) checked++;
    });
    if (checked === checkboxes.length) {
      checkboxes.forEach(function(checkbox) {
        checkbox.checked = false;
      });
    }
    view.dispatchEvent(new Event("change", {
      bubbles: true
    }));
  };
  var onFormatChange = function(e) {
    format_as = e.detail;
    slider.noUiSlider.set(slider.noUiSlider.get());
  };
  var sortCheckboxes = function() {
    var items = Array.from(checkboxes);
    items.sort(function(a, b) {
      return Number(a.value) - Number(b.value);
    });
    items.forEach(function(item) {
      item.parentNode.appendChild(item);
    });
    checkboxes = view.querySelectorAll(".checkboxes INPUT");
  };
  this.__construct = function() {
    sortCheckboxes();
    let margin = 10;
    let init_min = parseInt(slider.getAttribute("slider-min"));
    let init_max = parseInt(slider.getAttribute("slider-max"));
    let init_checked = [...checkboxes].filter((cb) => cb.checked).map((cb) => parseInt(cb.value, 10)).sort((a, b) => a - b);
    let start;
    if (init_checked.length === 1) {
      let min = init_checked[0];
      let max = Math.min(init_max, min + margin);
      if (max - min < margin) {
        min = Math.max(init_min, max - margin);
      }
      start = [min, max];
    } else {
      start = init_checked.length ? [init_checked[0], init_checked[init_checked.length - 1]] : [init_min, init_max];
    }
    noUiSlider.create(slider, {
      start,
      connect: true,
      tooltips: [tooltipFormatter, tooltipFormatter],
      step: 1,
      margin,
      range: { min: init_min, max: init_max }
    });
    slider.noUiSlider.on("set", toggleCheckboxes);
    Site.Events.on("form-range-format:change", onFormatChange);
  };
  this.__destruct = function() {
    slider.noUiSlider.destroy();
    Site.Events.off("form-range-format:change", onFormatChange);
  };
  Site.ExtendClass(this);
};
;
Site.FormRangeFields = function(param) {
  var view = this[0];
  var slider = view.querySelector(".slider");
  var format_as = view.getAttribute("range-format-as") || "default";
  var form = view.closest("FORM");
  var field_min = view.querySelector("[slider-field-min]");
  var field_max = view.querySelector("[slider-field-max]");
  var tooltipFormatter = {
    // to: value => '$' + Math.round(value),
    from: (value) => Number(String(value).replace("$", "")),
    to: function(value) {
      value = Math.round(value);
      switch (format_as) {
        case "inch":
        case "inches":
          return value + " in";
        case "foot":
        case "feet":
          return value + " ft";
        case "money":
          return "$" + value.toLocaleString("en-US");
        default:
          return value;
      }
    }
  };
  this.__construct = function() {
    let init_min = parseInt(slider.getAttribute("slider-min"));
    let init_max = parseInt(slider.getAttribute("slider-max"));
    noUiSlider.create(slider, {
      start: [
        field_min.value || init_min,
        field_max.value || init_max
      ],
      connect: true,
      tooltips: [tooltipFormatter, tooltipFormatter],
      step: 10,
      range: { min: init_min, max: init_max }
    });
    slider.noUiSlider.on("update", (values) => {
      let set_min = values[0];
      let set_max = values[1];
      if (set_min == init_min) {
        field_min.value = "";
      } else {
        field_min.value = Math.round(values[0]);
      }
      if (set_max == init_max) {
        field_max.value = "";
      } else {
        field_max.value = Math.round(values[1]);
      }
      form.dispatchEvent(new Event("change", { bubbles: true }));
    });
  };
  this.__destruct = function() {
    slider.noUiSlider.destroy();
  };
  Site.ExtendClass(this);
};
;
Site.FormRangeFormat = function(param) {
  var view = this[0];
  var links = view.querySelectorAll('[rel="form:range:set-format"]');
  var cookie_name = "FormRangeFormat";
  var format_as = Site.CookieJar.read(cookie_name) || view.getAttribute("format-default") || "default";
  var setActiveLink = function() {
    links.forEach(function(link) {
      if (link.getAttribute("format") === format_as) {
        link.classList.add("current");
      } else {
        link.classList.remove("current");
      }
    });
  };
  var setFormat = function(e) {
    e.preventDefault();
    format_as = this.getAttribute("format");
    Site.CookieJar.write(cookie_name, format_as, 365);
    setActiveLink();
    Site.Events.trigger("form-range-format:change", format_as);
  };
  this.__construct = function() {
    setActiveLink();
    links.forEach(function(link) {
      link.addEventListener("click", setFormat);
    });
  };
  this.__destruct = function() {
    links.forEach(function(link) {
      link.removeEventListener("click", setFormat);
    });
  };
  Site.ExtendClass(this);
};
;
Site.GridFilters = function(param) {
  var view = this[0];
  var wrapper = view.parentElement;
  var has_nav = view.querySelector(".navlist") !== null;
  var has_filters = view.querySelector(".right A") !== null;
  var form = wrapper.querySelector("FORM");
  var bar = view.querySelector(".bar");
  var results = wrapper.querySelector(".collection__results");
  var drawer = new Site.DrawerAbstract(view.nextElementSibling);
  var stuck_class = "--stuck";
  var stuck_detector = view.previousElementSibling;
  var stuck_observer;
  var refresh_delay = 500;
  var refresh_timer;
  var formChange = function() {
    clearTimeout(refresh_timer);
    results.classList.add("--refreshing");
    refresh_timer = setTimeout(function() {
      form.requestSubmit();
    }, refresh_delay);
  };
  var startRefreshing = function(e) {
    if (e.detail.name !== "products") return;
    results.classList.add("--refreshing");
  };
  var finishRefreshing = function(e) {
    if (e.detail.name !== "products") return;
    results.classList.remove("--refreshing");
    Site.Scrollbars.auto();
    Site.Events.trigger("header-sticky:listening", false);
    Site.Events.trigger("header-sticky:hide");
    Site.Scripts.Init(view);
    window.scrollTo({ top: view.parentElement.getBoundingClientRect().top + window.scrollY });
    setTimeout(function() {
      Site.Events.trigger("header-sticky:listening", true);
    }, 2500);
  };
  var onResetClick = function(e) {
    var trigger = e.target.closest('[rel="grid-filters:reset"]');
    if (!trigger || !form) return;
    form.querySelectorAll('INPUT[type="checkbox"]').forEach(function(checkbox) {
      checkbox.checked = false;
    });
    var first_radio = form.querySelector('INPUT[type="radio"]');
    if (first_radio) first_radio.checked = true;
    form.querySelectorAll(".slider").forEach(function(slider) {
      if (!slider.noUiSlider) return;
      var min = parseFloat(slider.getAttribute("slider-min"));
      var max = parseFloat(slider.getAttribute("slider-max"));
      slider.noUiSlider.set([min, max]);
    });
    clearTimeout(refresh_timer);
    results.classList.remove("--refreshing");
  };
  this.__construct = function() {
    if (has_nav && has_filters) {
      view.classList.add("--is-sticky");
      stuck_observer = new IntersectionObserver(function(entries) {
        view.classList.toggle(stuck_class, !entries[0].isIntersecting);
      }, { threshold: 0 });
      stuck_observer.observe(stuck_detector);
    }
    Site.Events.on("page:enter", startRefreshing);
    Site.Events.on("page:entered", finishRefreshing);
    wrapper.addEventListener("click", onResetClick);
    setTimeout(() => {
      if (form) form.addEventListener("change", formChange);
    }, 900);
  };
  this.__destruct = function() {
    clearTimeout(refresh_timer);
    if (stuck_observer) {
      stuck_observer.disconnect();
      stuck_observer = null;
    }
    if (form) form.removeEventListener("change", formChange);
    wrapper.removeEventListener("click", onResetClick);
    Site.Events.off("page:enter", startRefreshing);
    Site.Events.off("page:entered", finishRefreshing);
    drawer.destruct();
  };
  this.everyExit = function() {
    drawer.close();
  };
  Site.ExtendClass(this);
};
;
Site.GridModes = function(param) {
  var view = this[0];
  var buttons = view.querySelectorAll("BUTTON");
  var storage_key = "collection-grid-mode";
  var current = localStorage.getItem(storage_key) || "default";
  var changeMode = function(e) {
    var valid = e.target.closest("BUTTON[data-mode]");
    if (!valid) return;
    e.preventDefault();
    var wrapper = document.querySelector(".collection__results");
    var grid = document.querySelector("#collection-grid");
    current = e.target.dataset.mode;
    setActiveButton(current);
    wrapper.classList.add("--changing");
    setTimeout(function() {
      localStorage.setItem(storage_key, current);
      Array.from(grid.classList).forEach(function(cls) {
        if (cls.indexOf("--mode") === 0) grid.classList.remove(cls);
      });
      grid.classList.add("--mode-" + current);
      ScrollTrigger.refresh();
      wrapper.classList.remove("--changing");
    }, 450);
  };
  var setActiveButton = function(set) {
    buttons.forEach(function(button) {
      if (button.dataset.mode === set) {
        button.classList.add("--active");
      } else {
        button.classList.remove("--active");
      }
    });
  };
  this.__construct = function() {
    setActiveButton(current);
    view.addEventListener("click", changeMode);
  };
  this.__destruct = function() {
    view.removeEventListener("click", changeMode);
  };
  Site.ExtendClass(this);
};
;
Site.GridThumbnailsMobile = function(param) {
  var view = this[0];
  var initial_delay = 500;
  var loop_time = 5e3;
  var loop_delay = 3e3;
  var groups = [];
  var timeline = null;
  var start_timeout = null;
  var breakpoint = null;
  var buildGroups = function() {
    groups = [[], [], []];
    view.querySelectorAll(".product__cell").forEach(function(cell, index) {
      var image = cell.querySelector("IMG.alt-0");
      if (image) groups[index % 3].push(image);
    });
  };
  var buildTimeline = function() {
    timeline = gsap.timeline({ repeat: -1, paused: true });
    groups.forEach(function(group) {
      timeline.call(function() {
        group.forEach(function(image) {
          image.classList.add("show");
        });
      }, null, "+=" + loop_delay / 1e3);
      timeline.call(function() {
        group.forEach(function(image) {
          image.classList.remove("show");
        });
      }, null, "+=" + loop_time / 1e3);
    });
  };
  var turnOn = function() {
    buildGroups();
    buildTimeline();
    start_timeout = setTimeout(function() {
      timeline.play();
    }, initial_delay);
  };
  var turnOff = function() {
    clearTimeout(start_timeout);
    if (timeline) {
      timeline.kill();
      timeline = null;
    }
    groups.forEach(function(group) {
      group.forEach(function(image) {
        image.classList.remove("show");
      });
    });
  };
  this.__construct = function() {
    breakpoint = new Site.BreakpointConditional("eq", "mobile", turnOn, turnOff);
  };
  this.__destruct = function() {
    if (breakpoint) breakpoint.destroy();
    turnOff();
  };
  Site.ExtendClass(this);
};
;
Site.GridThumbnails = function(param) {
  var view = this[0];
  var timer;
  var breakpoint;
  var showImage = function(trigger, show) {
    var cell = trigger.closest(".product__cell");
    if (!cell) return;
    var image = cell.querySelector(".alt-" + trigger.dataset.index);
    if (!image) return;
    clearTimeout(timer);
    resetImage();
    if (trigger.dataset.index > 0) {
      var initial = cell.querySelector("IMG.default");
      if (initial) initial.classList.add("hide");
    }
    var badge = cell.querySelector(".badge");
    if (badge) badge.classList.toggle("--hidden", show && trigger.dataset.index > 0);
    image.classList.toggle("show", show);
  };
  var resetImage = function() {
    clearTimeout(timer);
    view.querySelectorAll("IMG.default.hide").forEach(function(image) {
      image.classList.remove("hide");
    });
    view.querySelectorAll(".alt.show").forEach(function(image) {
      image.classList.remove("show");
    });
    view.querySelectorAll(".badge.--hidden").forEach(function(badge) {
      badge.classList.remove("--hidden");
    });
  };
  var delayResetImage = function() {
    clearTimeout(timer);
    timer = setTimeout(resetImage, 200);
  };
  var onMouseOver = function(e) {
    var trigger = e.target.closest(".alt-hover");
    if (!trigger) return;
    showImage(trigger, true);
  };
  var onMouseOut = function(e) {
    var trigger = e.target.closest(".alt-hover");
    if (!trigger) return;
    if (trigger.contains(e.relatedTarget)) return;
    delayResetImage();
  };
  var onClick = function(e) {
    var trigger = e.target.closest('[rel="product-cell:more"]');
    if (!trigger) return;
    e.preventDefault();
    var cell = trigger.closest(".product__cell");
    if (!cell) return;
    var expand = cell.querySelector(".more-models");
    var open = cell.classList.toggle("--open");
    if (expand) expand.style.maxHeight = open ? expand.scrollHeight + "px" : "";
  };
  var turnOn = function() {
    document.addEventListener("mouseover", onMouseOver);
    document.addEventListener("mouseout", onMouseOut);
    document.addEventListener("click", onClick);
  };
  var turnOff = function() {
    document.removeEventListener("mouseover", onMouseOver);
    document.removeEventListener("mouseout", onMouseOut);
    document.removeEventListener("click", onClick);
    resetImage();
  };
  this.__construct = function() {
    breakpoint = new Site.BreakpointConditional("gte", "tablet", turnOn, turnOff);
  };
  this.__destruct = function() {
    if (breakpoint) breakpoint.destroy();
    turnOff();
  };
  Site.ExtendClass(this, "persistent");
};
;
Site.HeaderAnnouncement = function(param) {
  var view = this[0];
  var cookie_name = "AnnouncementBar";
  var cookie_value = view.getAttribute("announcement-cookie");
  var close = function() {
    Site.CookieJar.write(cookie_name, cookie_value, 365);
    document.documentElement.classList.remove("--has-announcement-bar");
    setTimeout(function() {
      Site.Events.trigger("header-announcement:close");
    }, 600);
  };
  var onClick = function(e) {
    if (e.target.closest('[rel="announcement-bar:close"]')) {
      e.preventDefault();
      close();
    }
  };
  this.__construct = function() {
    view.addEventListener("click", onClick);
  };
  Site.ExtendClass(this);
};
;
Site.HeaderDesktop = function(param) {
  var header = this[0];
  var bars = header.querySelectorAll('[rel="header:bar"]');
  var triggers = header.querySelectorAll('[rel="header:open"]');
  var hovers = header.querySelectorAll(".right-menu");
  var panels = header.querySelectorAll(".panel");
  var overlays = header.querySelectorAll(".overlay");
  var close_timer;
  var current;
  var open = function(button, panel) {
    Site.Events.trigger("drawers:close");
    clearTimeout(close_timer);
    if (current && current !== panel) {
      current.classList.remove("--open");
      current.setAttribute("aria-hidden", "true");
      header.querySelectorAll('[aria-expanded="true"]').forEach(function(elem) {
        elem.setAttribute("aria-expanded", "false");
      });
    }
    header.classList.remove("--search-open");
    if (!panel) {
      current = null;
      return;
    }
    button.setAttribute("aria-expanded", "true");
    header.classList.add("--open");
    if (panel.classList.contains("search")) {
      header.classList.add("--search-open");
    }
    panel.classList.add("--open");
    panel.setAttribute("aria-hidden", "false");
    if (panel.classList.contains("search")) {
      var input = panel.querySelector('input[type="search"]');
      if (input) input.focus();
    }
    current = panel;
    Site.Scrollbars.off();
  };
  var close = function() {
    clearTimeout(close_timer);
    if (!current) return;
    header.classList.remove("--open");
    header.classList.remove("--search-open");
    current.classList.remove("--open");
    current.setAttribute("aria-hidden", "true");
    current = null;
    triggers.forEach(function(trigger) {
      trigger.setAttribute("aria-expanded", "false");
    });
    Site.Scrollbars.auto();
  };
  var delayClose = function() {
    clearTimeout(close_timer);
    close_timer = setTimeout(close, 700);
  };
  var cancelClose = function() {
    clearTimeout(close_timer);
  };
  var onEngageHover = function(e) {
    var bar = e.currentTarget.closest(".bar");
    var button = header.querySelector('.right [aria-controls="menu-panel"]');
    var panel = document.getElementById(button.getAttribute("aria-controls"));
    open(button, panel);
  };
  var onEngageTrigger = function(e) {
    var button = e.currentTarget;
    var panel = document.getElementById(button.getAttribute("aria-controls"));
    if (current === panel) {
    } else {
      open(button, panel);
    }
  };
  var onKeydown = function(e) {
    if (e.key !== "Escape") return;
    close();
  };
  this.__construct = function() {
    hovers.forEach(function(hover) {
      hover.addEventListener("mouseenter", onEngageHover);
    });
    triggers.forEach(function(trigger) {
      trigger.addEventListener("click", onEngageTrigger);
    });
    overlays.forEach(function(overlay) {
      overlay.addEventListener("mouseenter", delayClose);
      overlay.addEventListener("mouseleave", cancelClose);
      overlay.addEventListener("click", close);
    });
    panels.forEach(function(panel) {
      panel.classList.add("--ready");
    });
    header.addEventListener("mouseleave", delayClose);
    document.addEventListener("keydown", onKeydown);
    Site.Events.on("header:close", close);
  };
  this.everyExit = function() {
    close();
  };
  this.everyEntered = function() {
    close();
  };
  Site.ExtendClass(this);
};
;
Site.HeaderMobile = function(param) {
  var view = this[0];
  var drawer = new Site.DrawerAbstract(view);
  var layers = view.querySelector(".layers");
  var layer_classname = "--submenu";
  var onClick = function(e) {
    var submenu = e.target.closest('[rel="header-mobile:submenu"]');
    var go_back = e.target.closest('[rel="header-mobile:go-back"]');
    if (!submenu && !go_back) return;
    e.preventDefault();
    if (go_back) {
      layers.classList.remove(layer_classname);
      return;
    }
    if (submenu) {
      view.querySelectorAll(".sub > DIV").forEach(function(panel) {
        panel.classList.remove("--active");
      });
      var match = view.querySelector('.sub > [data-submenu="' + submenu.dataset.menu + '"]');
      if (match) match.classList.add("--active");
      layers.classList.add(layer_classname);
      return;
    }
  };
  this.__construct = function() {
    view.addEventListener("click", onClick);
  };
  this.everyExit = function() {
    drawer.close();
    setTimeout(function() {
      layers.classList.remove(layer_classname);
    }, 600);
  };
  Site.ExtendClass(this);
};
;
Site.HeaderSticky = function() {
  var view = this[0];
  var bar_sticky = view.querySelectorAll("HEADER.main .bar.sticky, HEADER.mobile .bar.sticky");
  var listening = true;
  var ticking = false;
  var scroll_last = 0;
  var scroll_threshold = 200;
  var scroll_threshold_active = scroll_threshold;
  var setBarStickyInert = function(state) {
    bar_sticky.forEach(function(el) {
      el.inert = state;
    });
  };
  var updateScrollThreshold = function() {
    if (!document.documentElement.classList.contains("--has-announcement-bar")) {
      scroll_threshold_active = scroll_threshold;
      return;
    }
    var announcement_height = parseFloat(getComputedStyle(document.body).getPropertyValue("--announcement-height")) || 0;
    scroll_threshold_active = scroll_threshold + announcement_height;
  };
  var _debounce = function(fn, wait) {
    var timer;
    return function() {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  };
  var onScroll = function() {
    if (!listening) return;
    var scroll_top = window.pageYOffset || document.documentElement.scrollTop;
    var scrolling_up = scroll_top < scroll_last;
    var past_threshold = scroll_top > scroll_threshold_active;
    if (!past_threshold) {
      view.classList.remove("--header-sticky", "--header-sticky-show");
      setBarStickyInert(true);
    } else {
      view.classList.add("--header-sticky");
      view.classList.toggle("--header-sticky-show", scrolling_up);
      setBarStickyInert(!scrolling_up);
    }
    scroll_last = scroll_top;
  };
  var onScrollRequest = function() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function() {
      onScroll();
      ticking = false;
    });
  };
  var setListening = function(e) {
    var state = !!e.detail;
    if (state) {
      scroll_last = window.pageYOffset || document.documentElement.scrollTop;
    }
    listening = state;
  };
  var hide = function() {
    view.classList.remove("--header-sticky-show");
    setBarStickyInert(true);
  };
  this.__construct = function() {
    updateScrollThreshold();
    window.addEventListener("scroll", onScrollRequest, { passive: true });
    window.addEventListener("resize", _debounce(updateScrollThreshold, 250));
    Site.Events.on("header-sticky:hide", hide);
    Site.Events.on("header-sticky:listening", setListening);
    Site.Events.on("header-announcement:close", updateScrollThreshold);
    onScroll();
  };
  Site.ExtendClass(this);
};
;
Site.ImageEnlarge = function(param) {
  var view = this[0];
  var abstract = Site.ModalAbstract(view, { show_loading: false, size: "fullscreen" });
  var open = function(e) {
    var trigger = e.target.closest('[rel="image-enlarge:open"]');
    var wrapper = document.getElementById(trigger.getAttribute("enlarge-wrap"));
    if (!wrapper) {
      c({ primary: "ImageEnlarge" }, { error: "\u26A0\uFE0F wrapper not found" });
      return;
    }
    var triggers = wrapper.querySelectorAll('[rel="image-enlarge:open"]');
    var index = Array.prototype.indexOf.call(triggers, trigger);
    var slides = Array.prototype.map.call(triggers, function(item) {
      var clone = item.cloneNode(true);
      clone.querySelectorAll(".display-none").forEach(function(el) {
        el.classList.remove("display-none");
      });
      return '<div class="splide__slide slide">' + clone.innerHTML + "</div>";
    }).join("");
    var html = '<div class="module__slideshow splide" data-script="Slideshow" slideshow-arrows="true" slideshow-start="' + index + '"><div class="splide__track"><ul class="splide__list">' + slides + "</ul></div></div>";
    abstract.open(html);
  };
  var onKey = function(e) {
    if (abstract.isOpen() && e.key === "Escape") abstract.close();
  };
  var onClick = function(e) {
    if (e.target.closest('[rel="image-enlarge:close"]')) {
      e.preventDefault();
      abstract.close();
    }
    if (e.target.closest('[rel="image-enlarge:open"]')) {
      e.preventDefault();
      open(e);
    }
  };
  this.__construct = function() {
    document.addEventListener("keyup", onKey);
    document.addEventListener("click", onClick);
  };
  this.__destruct = function() {
    Site.Scrollbars.auto();
  };
  Site.ExtendClass(this);
};
;
Site.MailingList = function(param) {
  var form = this[0];
  var input = form.querySelector('input[type="email"]');
  var result = form.querySelector(".response");
  var result_timer = null;
  var onResponse = function(data) {
    if (data && data.result === "success") {
      let message = data.msg || "Thanks for subscribing!";
      updateResponse(message);
      if (input) {
        input.value = "";
        input.blur();
      }
      clearTimeout(result_timer);
      result_timer = setTimeout(function() {
        result.classList.add("--fadeout");
      }, 8e3);
    } else if (result) {
      let message = data && data.msg || "Something went wrong. Please try again.";
      updateResponse(message);
    }
  };
  var updateResponse = function(message) {
    result.textContent = message;
    result.classList.remove("--fadeout");
  };
  var onSubmit = function(e) {
    e.preventDefault();
    if (!input || !input.value.trim()) return;
    form.classList.add("--processing");
    var cleanup = function() {
      form.classList.remove("--processing");
    };
    Site.Utils.jsonp(form, "c").then(function(data) {
      onResponse(data);
      cleanup();
    }).catch(function() {
      if (result) updateResponse("Something went wrong. Please try again.");
      cleanup();
    });
  };
  this.__construct = function() {
    form.addEventListener("submit", onSubmit);
  };
  this.__destruct = function() {
  };
  Site.ExtendClass(this);
};
;
Site.ModalGeolocation = function(param) {
  var view = this[0];
  var abstract = Site.ModalAbstract(view, { show_loading: false });
  var cookie_name = "ModalGeolocation";
  var cookie_value = view.getAttribute("geolocation-cookie") || "1";
  var open_delay = 900;
  var region = "jp";
  var detectOpen = function() {
    fetch(window.Shopify.routes.root + "browsing_context_suggestions.json").then(function(r) {
      return r.json();
    }).then(function(data) {
      var user_country = data.detected_values.country.handle;
      var europe_countries = ["AL", "AD", "AT", "BY", "BE", "BA", "BG", "CZ", "HR", "DK", "EE", "FI", "FR", "GE", "DE", "GR", "GG", "HU", "IS", "IE", "IM", "IT", "JE", "LV", "LI", "LT", "LU", "MK", "MT", "MD", "MC", "ME", "NL", "NO", "PL", "PT", "RO", "RU", "SM", "RS", "SK", "SI", "ES", "SE", "CH", "TR", "UA", "GB", "VA"];
      var mideast_countries = ["AM", "AZ", "BH", "CY", "IL", "JO", "KZ", "KW", "LB", "OM", "PS", "QA", "SA", "AE", "YE"];
      var oceania_countries = ["AU", "NZ"];
      var usmca_countries = ["US", "CA", "MX"];
      if (europe_countries.includes(user_country)) {
        c([{ type: "primary", text: "ModalGeolocation" }, { text: "Detected Europe" }]);
        region = "eu";
        open();
        return;
      } else if (user_country == "JP") {
        c([{ type: "primary", text: "ModalGeolocation" }, { text: "Detected Japan" }]);
        region = "jp";
        open();
      } else if (oceania_countries.includes(user_country)) {
        c([{ type: "primary", text: "ModalGeolocation" }, { text: "Detected Oceania" }]);
        region = "oceania";
        open();
      } else if (mideast_countries.includes(user_country)) {
        c([{ type: "primary", text: "ModalGeolocation" }, { text: "Detected Middle East" }]);
        region = "mideast";
        open();
      } else if (!usmca_countries.includes(user_country)) {
        c([{ type: "primary", text: "ModalGeolocation" }, { text: "Detected Abroad" }]);
        region = "abroad";
        open();
      }
    });
  };
  var open = function() {
    view.addEventListener("click", onClick);
    view.querySelector(".region." + region).style.display = "block";
    setTimeout(abstract.open, open_delay);
  };
  var close = function() {
    Site.CookieJar.write(cookie_name, cookie_value, 100);
    abstract.close();
    view.removeEventListener("click", onClick);
  };
  var onClick = function(e) {
    if (e.target.closest('[rel="modal-geolocation:close"]')) {
      e.preventDefault();
      document.removeEventListener("click", onClick);
      close();
    }
  };
  this.everyEntered = function() {
    if (Site.Utils.getQueryParam("geolocation")) {
      region = Site.Utils.getQueryParam("geolocation");
      open();
      return false;
    }
    if (Site.CookieJar.read(cookie_name) == cookie_value) {
      return false;
    }
    detectOpen();
  };
  Site.ExtendClass(this, "persistent");
};
;
Site.ModalPromo = function(param) {
  var view = this[0];
  var abstract = Site.ModalAbstract(view, { show_loading: false });
  var cookie_name = "ModalPromo";
  var cookie_value = view.getAttribute("promo-cookie") || "3";
  var pageview_trigger = view.getAttribute("promo-pageview") || 3;
  var pageview_current = 1;
  var open_delay = 1300;
  var open = function() {
    c({ primary: "ModalPromo" }, "Open");
    document.addEventListener("click", onClick);
    abstract.open();
  };
  var close = function() {
    Site.CookieJar.write(cookie_name, cookie_value, 30);
    abstract.close();
    view.removeEventListener("click", onClick);
  };
  var onClick = function(e) {
    if (e.target.closest('[rel="modal-promo:close"]')) {
      e.preventDefault();
      document.removeEventListener("click", onClick);
      close();
    }
  };
  this.everyEntered = function() {
    if (Site.Utils.getQueryParam("modal") == "promo") {
      open_delay = 300;
      setTimeout(open, open_delay);
      return;
    }
    if (Site.CookieJar.read(cookie_name) == cookie_value) {
      return false;
    }
    if (pageview_current >= pageview_trigger) {
      setTimeout(open, open_delay);
    } else {
      c({ primary: "ModalPromo" }, pageview_current);
      pageview_current++;
    }
  };
  Site.ExtendClass(this, "persistent");
};
;
Site.NavSelect = function() {
  var view = this[0];
  var select = view.tagName === "SELECT" ? view : view.querySelector("select");
  var display = view.querySelector(".display");
  var onChange = function() {
    var subview = select.getAttribute("subview") || view.getAttribute("subview");
    if (subview) {
      Site.PageLoaderSubview.load(select.value, subview);
    } else {
      barba.go(select.value);
    }
    if (display) {
      display.textContent = select.options[select.selectedIndex].textContent;
    }
  };
  this.__construct = function() {
    select.addEventListener("change", onChange);
  };
  this.__destruct = function() {
    select.removeEventListener("change", onChange);
  };
  Site.ExtendClass(this);
};
;
Site.ProductImages = function(param) {
  var page = param.container instanceof Element ? param.container : document;
  var view = this[0];
  var abstract = Site.ModalAbstract(view, { show_loading: false, size: "enlarge", clear_on_close: false });
  var modal_window = view.querySelector(".modal-content");
  var content = view.querySelector(".target");
  var images = page.querySelectorAll(".images .track .image");
  var pswp;
  var zoom_data;
  var open = function(e) {
    var image = e.target.closest('[rel="product-image:click"]');
    var image_index = image.getAttribute("enlarge");
    var index = parseInt(image_index, 10) - 1;
    if (Site.Breakpoint.eq("mobile")) {
      pswp = new PhotoSwipe({
        arrowNextSVG: '<svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 10.3535L15 5.35352L10 0.353515" stroke="white"/><path d="M15 5.35352H0" stroke="white"/></svg>',
        arrowPrevSVG: '<svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.70711 10.3535L0.707107 5.35352L5.70711 0.353515" stroke="white"/><path d="M0.707107 5.35352H15.7071" stroke="white"/></svg>',
        closeSVG: '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.6066 2.68817e-05L11.3137 0.707134L0.707099 11.3137L-7.62939e-06 10.6066L10.6066 2.68817e-05Z" fill="white"/><path d="M11.6671 10.6066L10.96 11.3137L0.353432 0.707107L1.06054 0L11.6671 10.6066Z" fill="white"/></svg>',
        dataSource: zoom_data,
        index,
        bgClickAction: "close",
        bgOpacity: 1,
        imageClickAction: "zoom",
        wheelToZoom: false,
        maxZoomLevel: 1.5,
        zoomAnimationDuration: 0,
        zoom: false,
        counter: false
      });
      pswp.init();
    } else {
    }
  };
  var onKey = function(e) {
    if (abstract.isOpen() && e.key === "Escape") abstract.close();
  };
  var onClick = function(e) {
    if (e.target.closest('[rel="product-image:close"]')) {
      e.preventDefault();
      abstract.close();
    }
    if (e.target.closest('[rel="product-image:click"]')) {
      e.preventDefault();
      open(e);
    }
  };
  this.__construct = function() {
    zoom_data = [...images].map(function(image) {
      var img = image.querySelector("img");
      var wrapper = image.querySelector(".img-wrapper");
      return {
        src: img.dataset.zoom,
        width: parseInt(wrapper.dataset.width, 10),
        height: parseInt(wrapper.dataset.height, 10),
        alt: image.dataset.alt || ""
      };
    });
    document.addEventListener("keyup", onKey);
    document.addEventListener("click", onClick);
  };
  this.__destruct = function() {
    document.removeEventListener("keyup", onKey);
    document.removeEventListener("click", onClick);
    if (Site.Breakpoint.eq("mobile")) {
      if (pswp) pswp.destroy();
    }
    Site.Scrollbars.auto();
  };
  Site.ExtendClass(this, "persistent");
};
;
Site.ProductOptions = function(param) {
  var page = param.container instanceof Element ? param.container : document;
  var form = this[0];
  var selects = form.querySelectorAll("[data-option-index]");
  var variant_input = form.querySelector(".variant-id");
  var submit_button = form.querySelector('[type="submit"]');
  var submit_soldout = form.querySelector(".action.sold-out");
  var submit_available = form.querySelector(".action.available");
  var variants = JSON.parse(form.dataset.variants);
  var price_regular = page.querySelector("#ProductPrice .price:not(.member)");
  var price_member = page.querySelector("#ProductPrice .price.member");
  var getCurrentVariant = function() {
    let options = Array.from(selects).map(function(s) {
      return s.value;
    });
    let variant = variants.find(function(v) {
      return v.options.every(function(o, i) {
        return o === options[i];
      });
    });
    if (variant == void 0) {
      var default_variant = variants.find(function(v) {
        return v.available;
      }) || variants[0];
      return default_variant;
    }
    return variant;
  };
  var updateImages = function(variant) {
    var has_variant_image = variant && variant.featured_image;
    document.querySelectorAll(".images .cell[data-variant-ids]").forEach(function(cell) {
      var ids = cell.dataset.variantIds.split(",").filter(Boolean);
      var show = !has_variant_image || ids.indexOf(String(variant.id)) !== -1;
      cell.classList.toggle("--hidden-variant", !show);
    });
    var pairs_1 = document.querySelector(".--show-pairs-1");
    var pairs_2 = document.querySelector(".--show-pairs-2");
    if (pairs_1) pairs_1.classList.remove("--show-pairs-1");
    if (pairs_2) pairs_2.classList.remove("--show-pairs-2");
  };
  var formatMoney = function(cents) {
    var amount = (cents / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return "$" + amount.replace(".00", "");
  };
  var updatePrice = function(variant) {
    if (!variant || !price_regular) return;
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      price_regular.innerHTML = '<span class="strike">' + formatMoney(variant.compare_at_price) + '</span> &nbsp;<span class="color-red">' + formatMoney(variant.price) + "</span>";
    } else {
      price_regular.innerHTML = formatMoney(variant.price);
    }
    if (price_member) {
      var discount = parseFloat(price_member.dataset.discount) || 1;
      price_member.innerHTML = formatMoney(Math.round(variant.price * discount)) + ' <span class="text__nav">Members</span>';
    }
  };
  var updateVariant = function() {
    var variant = getCurrentVariant();
    var incomplete = Array.from(selects).some(function(s) {
      return s.value === "";
    });
    updateImages(incomplete ? null : variant);
    updatePrice(variant);
    if (!variant) {
      variant_input.value = "";
      if (submit_button) submit_button.classList.add("--incomplete");
      if (submit_available) submit_available.style.display = "";
      if (submit_soldout) submit_soldout.style.display = "none";
      return;
    }
    variant_input.value = variant.id;
    if (submit_button) submit_button.classList.remove("--incomplete");
    if (variant.available) {
      if (submit_available) submit_available.style.display = "";
      if (submit_soldout) submit_soldout.style.display = "none";
    } else {
      if (submit_available) submit_available.style.display = "none";
      if (submit_soldout) submit_soldout.style.display = "";
    }
  };
  var onSubmitClick = function(e) {
    if (!submit_button.classList.contains("--incomplete")) return;
    e.preventDefault();
    Site.Alert("Please select all options");
  };
  this.__construct = function() {
    selects.forEach(function(s) {
      s.addEventListener("change", updateVariant);
    });
    if (submit_button) submit_button.addEventListener("click", onSubmitClick);
  };
  this.__destruct = function() {
    selects.forEach(function(s) {
      s.removeEventListener("change", updateVariant);
    });
    if (submit_button) submit_button.removeEventListener("click", onSubmitClick);
  };
  Site.ExtendClass(this);
};
;
Site.ProductRecommendations = function(param) {
  var view = this[0];
  var url = view.dataset.url;
  var cells = view.querySelector(".cells");
  var carousel_el = view.querySelector(".carousel__scroll");
  var carousel = null;
  var initCarousel = function() {
    if (!carousel_el) return;
    carousel = [carousel_el];
    Site.CarouselScroll.call(carousel);
  };
  var destroyCarousel = function() {
    if (!carousel) return;
    carousel.__destruct();
    carousel = null;
  };
  this.__construct = function() {
    initCarousel();
    if (!url) return;
    fetch(url).then(function(response) {
      return response.text();
    }).then(function(html) {
      var doc = document.createElement("div");
      doc.innerHTML = html;
      var content = doc.querySelector(".cells");
      if (!content) return;
      destroyCarousel();
      cells.innerHTML = content.innerHTML;
      initCarousel();
    });
  };
  this.__destruct = function() {
    destroyCarousel();
  };
  Site.ExtendClass(this);
};
;
Site.ProductSidebar = function(param) {
  var view = this[0];
  var sides = view.querySelectorAll(".sticky-toggle");
  var sticky = false;
  var instance = null;
  var breakpoint = null;
  var detectSticky = function() {
    let shorter_side = null;
    sides.forEach(function(side) {
      if (!shorter_side || side.offsetHeight < shorter_side.offsetHeight) {
        shorter_side = side;
      }
    });
    sticky = shorter_side;
    sticky.classList.add("sticky");
  };
  var turnOn = function() {
    if (view.querySelectorAll(".images .cell").length < 2) return;
    detectSticky();
    var options = {
      containerSelector: ".top",
      innerWrapperSelector: ".sticky-inner",
      stickyClass: "--affixed",
      topSpacing: 90
      // bottomSpacing: 20,
    };
    instance = new StickySidebar(sticky, options);
  };
  var turnOff = function() {
    if (instance) {
      instance.destroy();
      instance = null;
    }
    if (sticky) sticky.classList.remove("sticky");
    sticky = false;
  };
  this.__construct = function() {
    breakpoint = new Site.BreakpointConditional("gte", "tablet", turnOn, turnOff);
  };
  this.__destruct = function() {
    if (breakpoint) breakpoint.destroy();
    turnOff();
  };
  Site.ExtendClass(this);
};
;
Site.ProductSoldout = function(param) {
  var view = this[0];
  var is_open = false;
  var modal;
  var overlay;
  var open = function(e) {
    if (e) e.preventDefault();
    if (!modal) return;
    is_open = true;
    modal.classList.add("--active");
    overlay.classList.add("--active");
  };
  var close = function(e) {
    if (e) e.preventDefault();
    is_open = false;
    modal.classList.remove("--active");
    overlay.classList.remove("--active");
  };
  var onClick = function(e) {
    var open_trigger = e.target.closest('[rel="product:oos"]');
    var close_trigger = e.target.closest('[rel="product:oos:close"]');
    if (open_trigger) open(e);
    if (close_trigger) close(e);
  };
  var onKeydown = function(e) {
    if (!is_open) return;
    if (e.key === "Escape") {
      close();
      return;
    }
    if (e.key === "Enter" && e.target.tagName === "INPUT" && modal.contains(e.target)) {
      e.preventDefault();
      var button = e.target.parentElement.querySelector("BUTTON");
      if (button) button.click();
    }
  };
  this.onEntered = function() {
    modal = document.getElementById("oos-modal");
    overlay = document.getElementById("oos-overlay");
  };
  this.__construct = function() {
    document.addEventListener("click", onClick);
    document.addEventListener("keydown", onKeydown);
  };
  this.__destruct = function() {
    document.removeEventListener("click", onClick);
    document.removeEventListener("keydown", onKeydown);
  };
  Site.ExtendClass(this);
};
;
Site.ProductStickyButton = function(param) {
  var view = this[0];
  var atc_bar = view.querySelector(".atc");
  var atc_form = view.querySelector("FORM");
  var atc_button = atc_form.querySelector('BUTTON[type="submit"]');
  var atc_offset = 0;
  var atc_ticking = false;
  var updateOffset = function() {
    atc_offset = atc_form.getBoundingClientRect().top + window.pageYOffset - window.innerHeight;
  };
  var onScroll = function() {
    var scroll_top = window.pageYOffset || document.documentElement.scrollTop;
    atc_bar.classList.toggle("--show", scroll_top < atc_offset);
  };
  var onScrollRequest = function() {
    if (atc_ticking) return;
    atc_ticking = true;
    window.requestAnimationFrame(function() {
      onScroll();
      atc_ticking = false;
    });
  };
  var onResizeDebounce = function(fn, wait) {
    var timer;
    return function() {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  };
  var onResize = onResizeDebounce(function() {
    updateOffset();
    onScroll();
  }, 250);
  var onClick = function(event) {
    var atc = event.target.closest('[rel="product:atc"]');
    if (!atc) return;
    event.preventDefault();
    if (atc_button.classList.contains("--incomplete")) {
      atc_form.scrollIntoView({ behavior: "smooth" });
    } else {
      atc_button.click();
    }
  };
  this.__construct = function() {
    if (!atc_bar) return;
    setTimeout(function() {
      atc_bar.addEventListener("click", onClick);
      updateOffset();
      onScroll();
      window.addEventListener("scroll", onScrollRequest, { passive: true });
      window.addEventListener("resize", onResize);
    }, 500);
  };
  this.__destruct = function() {
    if (!atc_bar) return;
    atc_bar.removeEventListener("click", onClick);
    window.removeEventListener("scroll", onScrollRequest);
    window.removeEventListener("resize", onResize);
  };
  Site.ExtendClass(this);
};
;
Site.Product = function(param) {
  Site.ExtendClass(this);
};
;
Site.RandomElement = function(param) {
  var view = this[0];
  var children = Array.from(view.children);
  this.__construct = function() {
    if (!children.length) return;
    children.forEach(function(child) {
      child.style.display = "none";
    });
    var index = Math.floor(Math.random() * children.length);
    children[index].style.display = "";
  };
  this.__destruct = function() {
    children.forEach(function(child) {
      child.style.removeProperty("display");
    });
  };
  Site.ExtendClass(this);
};
;
Site.SlideshowStory = function(param) {
  var view = this[0];
  var splide;
  var arrow_prev;
  var arrow_next;
  var counter;
  var arrow_path = "M22 15L27 20L22 25 M27 20L12 20";
  var onClick = function(e) {
    if (e.target.closest('[rel="slideshow:next"]')) {
      e.preventDefault();
      splide.go("+1");
    }
  };
  var onArrowPrev = function(e) {
    e.preventDefault();
    splide.go("-1");
  };
  var onArrowNext = function(e) {
    e.preventDefault();
    splide.go("+1");
  };
  var updateCounter = function() {
    if (!counter) return;
    counter.textContent = splide.index + 1 + "/" + splide.length;
  };
  this.__construct = function() {
    arrow_prev = view.querySelector(".arrow--prev");
    arrow_next = view.querySelector(".arrow--next");
    counter = view.querySelector(".counter");
    splide = new Splide(view, {
      type: "fade",
      rewind: true,
      drag: true,
      padding: false,
      autoHeight: true,
      arrows: false,
      arrowPath: arrow_path,
      pagination: true,
      keyboard: "global",
      speed: 2e3,
      reducedMotion: { speed: 2e3, rewindSpeed: 2e3 },
      interval: 7e3,
      updateOnMove: true,
      breakpoints: {
        1024: {
          // Tablet
          padding: 0,
          drag: true
        },
        767: {
          // Mobile
          autoplay: false
        }
      }
    });
    splide.on("mounted moved", updateCounter);
    splide.on("pagination:mounted", function(data) {
      data.list.classList.add("--numbers");
      data.items.forEach(function(item) {
        item.button.textContent = item.page + 1;
      });
    });
    splide.mount(window.splide.Extensions);
    view.querySelectorAll(".splide__slide").forEach(function(slide) {
      slide.style.transition = "opacity " + splide.options.speed + "ms " + splide.options.easing;
    });
    if (arrow_prev) arrow_prev.addEventListener("click", onArrowPrev);
    if (arrow_next) arrow_next.addEventListener("click", onArrowNext);
    view.addEventListener("click", onClick);
  };
  this.__destruct = function() {
    if (splide) splide.destroy();
    if (arrow_prev) arrow_prev.removeEventListener("click", onArrowPrev);
    if (arrow_next) arrow_next.removeEventListener("click", onArrowNext);
    view.removeEventListener("click", onClick);
  };
  Site.ExtendClass(this);
};
;
Site.Slideshow = function(param) {
  var view = this[0];
  var splide;
  var arrow_path = "M22 15L27 20L22 25 M27 20L12 20";
  var onClick = function(e) {
    if (e.target.closest('[rel="slideshow:next"]')) {
      e.preventDefault();
      splide.go("+1");
    }
  };
  this.__construct = function() {
    let option_dots = view.getAttribute("slideshow-dots") == "true" || view.getAttribute("slideshow-dots") == "1";
    let option_numbers = view.getAttribute("slideshow-numbers") == "true" || view.getAttribute("slideshow-numbers") == "1";
    let option_arrows = view.getAttribute("slideshow-arrows") == "true" || view.getAttribute("slideshow-arrows") == "1";
    let option_autoplay = view.getAttribute("slideshow-autoplay") == "true" || view.getAttribute("slideshow-autoplay") == "1";
    let option_start = parseInt(view.getAttribute("slideshow-start"), 10) || 0;
    if (view.querySelectorAll(".splide__slide").length == 1) {
      option_arrows = false;
      option_dots = false;
      option_numbers = false;
    }
    splide = new Splide(view, {
      type: "fade",
      start: option_start,
      rewind: true,
      drag: true,
      padding: false,
      arrows: option_arrows,
      arrowPath: arrow_path,
      pagination: option_dots || option_numbers,
      keyboard: "global",
      speed: 2e3,
      reducedMotion: { speed: 2e3, rewindSpeed: 2e3 },
      interval: 7e3,
      updateOnMove: true,
      breakpoints: {
        1024: {
          // Tablet
          padding: 0,
          drag: true
        },
        767: {
          // Mobile
          autoplay: false
        }
      },
      autoplay: "pause",
      pauseOnHover: false,
      intersection: {
        inView: { autoplay: option_autoplay },
        outView: { autoplay: false }
      }
    });
    if (option_numbers) {
      splide.on("pagination:mounted", function(data) {
        data.list.classList.add("--numbers");
        data.items.forEach(function(item) {
          item.button.textContent = item.page + 1;
        });
      });
    }
    splide.mount(window.splide.Extensions);
    view.querySelectorAll(".splide__slide").forEach(function(slide) {
      slide.style.transition = "opacity " + splide.options.speed + "ms " + splide.options.easing;
    });
    view.addEventListener("click", onClick);
  };
  this.__destruct = function() {
    if (splide) splide.destroy();
    view.removeEventListener("click", onClick);
  };
  Site.ExtendClass(this);
};
;
Site.Video = function(param) {
  var view = this[0];
  var target = view.querySelector(".player");
  var player = null;
  var observer = null;
  var is_visible = false;
  var reduced_motion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var autoplay = view.getAttribute("video-autoplay") === "true" && !reduced_motion;
  var fullscreen_btn = view.getAttribute("video-fullscreen") === "true";
  var media = null;
  var ratio = null;
  var ratio_observer = null;
  var syncPauseButton = function() {
    var pause_btn = view.querySelector('BUTTON[rel="video:pause"]');
    if (!pause_btn) return;
    pause_btn.textContent = player.paused ? "Play" : "Pause";
    pause_btn.setAttribute("aria-pressed", player.paused);
    pause_btn.classList.toggle("--paused", player.paused);
  };
  var syncUnmuteButton = function() {
    var unmute_btn = view.querySelector('BUTTON[rel="video:unmute"]');
    if (!unmute_btn) return;
    unmute_btn.textContent = player.muted ? "Sound On" : "Sound Off";
    unmute_btn.setAttribute("aria-pressed", player.muted);
    unmute_btn.classList.toggle("--muted", player.muted);
  };
  var syncCaptionsButton = function(active) {
    var captions_btn = view.querySelector('BUTTON[rel="video:captions"]');
    if (!captions_btn) return;
    if (active === void 0) active = player.captions.active;
    captions_btn.textContent = active ? "CC Off" : "CC On";
    captions_btn.setAttribute("aria-pressed", active);
    captions_btn.classList.toggle("--captions", active);
  };
  var syncFullscreenButton = function() {
    var fullscreen_btn2 = view.querySelector('[rel="video:fullscreen"]');
    if (!fullscreen_btn2) return;
    fullscreen_btn2.setAttribute("aria-label", player.fullscreen.active ? "Exit Fullscreen" : "Fullscreen");
    fullscreen_btn2.setAttribute("aria-pressed", player.fullscreen.active);
    fullscreen_btn2.classList.toggle("--fullscreen", player.fullscreen.active);
  };
  var coverSize = {
    setup: function() {
      if (media.tagName !== "IFRAME") return;
      var wrapper = view.querySelector(".plyr__video-wrapper");
      if (!wrapper) return;
      var value = wrapper.style.aspectRatio;
      if (value) {
        coverSize.start(value);
        return;
      }
      ratio_observer = new MutationObserver(function() {
        var updated = wrapper.style.aspectRatio;
        if (!updated) return;
        ratio_observer.disconnect();
        ratio_observer = null;
        coverSize.start(updated);
      });
      ratio_observer.observe(wrapper, { attributes: true, attributeFilter: ["style"] });
    },
    start: function(value) {
      var parts = value.split("/");
      ratio = parseFloat(parts[0]) / parseFloat(parts[1]);
      if (!ratio) return;
      media.style.position = "absolute";
      media.style.left = "50%";
      media.style.top = "50%";
      media.style.transform = "translate3d(-50%, -50%, 0)";
      window.addEventListener("resize", coverSize.resize);
      coverSize.resize();
    },
    resize: function() {
      if (!ratio) return;
      var w = view.clientWidth;
      var h = view.clientHeight;
      var final_width, final_height;
      if (w / h > ratio) {
        final_width = w;
        final_height = w / ratio;
      } else {
        final_height = h;
        final_width = h * ratio;
      }
      media.style.width = Math.ceil(final_width) + "px";
      media.style.height = Math.ceil(final_height) + "px";
    },
    destroy: function() {
      window.removeEventListener("resize", coverSize.resize);
      if (ratio_observer) {
        ratio_observer.disconnect();
        ratio_observer = null;
      }
    },
    suspend: function() {
      if (!media || media.tagName !== "IFRAME") return;
      window.removeEventListener("resize", coverSize.resize);
      media.style.width = "";
      media.style.height = "";
    },
    resume: function() {
      if (!media || media.tagName !== "IFRAME" || !ratio) return;
      window.addEventListener("resize", coverSize.resize);
      coverSize.resize();
    }
  };
  var autoplayScroll = {
    setup: function() {
      observer = new IntersectionObserver(autoplayScroll.trigger, { threshold: 0 });
      observer.observe(view);
    },
    trigger: function(entries) {
      is_visible = entries[0].isIntersecting;
      if (is_visible) {
        player.play();
      } else {
        player.pause();
      }
    },
    destroy: function() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    }
  };
  var onClick = function(e) {
    if (!player) return;
    var pause_btn = e.target.closest('[rel="video:pause"]');
    var unmute_btn = e.target.closest('[rel="video:unmute"]');
    var captions_btn = e.target.closest('[rel="video:captions"]');
    var fullscreen_btn2 = e.target.closest('[rel="video:fullscreen"]');
    if (pause_btn) {
      player.togglePlay();
      autoplayScroll.destroy();
      return;
    }
    if (unmute_btn) {
      player.muted = !player.muted;
      return;
    }
    if (captions_btn) {
      if (player.isVimeo) {
        player.embed.getTextTracks().then(function(tracks) {
          var track = tracks[0];
          if (!track) return;
          var enabling = track.mode !== "showing";
          if (enabling) {
            player.embed.enableTextTrack(track.language, track.kind);
          } else {
            player.embed.disableTextTrack();
          }
          syncCaptionsButton(enabling);
        });
      } else {
        player.toggleCaptions();
      }
      return;
    }
    if (fullscreen_btn2) {
      player.fullscreen.toggle();
      return;
    }
  };
  this.__construct = function() {
    if (!target) return;
    player = new Plyr(target, {
      controls: [],
      autoplay: false,
      muted: true,
      loop: { active: true },
      fullscreen: { iosNative: fullscreen_btn, container: ".video-wrapper" },
      vimeo: {
        byline: false,
        portrait: false,
        title: false,
        transparent: false,
        controls: false,
        dnt: true
      }
    });
    player.on("ready", function() {
      setTimeout(function() {
        view.classList.add("--ready");
      }, 500);
      media = view.querySelector(".plyr__video-wrapper video, .plyr__video-wrapper iframe");
      if (media) {
        media.setAttribute("aria-hidden", "true");
        media.setAttribute("tabindex", "-1");
        coverSize.setup();
      }
      syncPauseButton();
      syncUnmuteButton();
      syncCaptionsButton();
      syncFullscreenButton();
    });
    player.on("playing", syncPauseButton);
    player.on("playing", function() {
      if (observer && !is_visible) player.pause();
    });
    player.on("pause", syncPauseButton);
    player.on("volumechange", syncUnmuteButton);
    player.on("captionsenabled", syncCaptionsButton);
    player.on("captionsdisabled", syncCaptionsButton);
    player.on("enterfullscreen", function() {
      syncFullscreenButton();
      view.classList.add("--native-fullscreen");
      coverSize.suspend();
    });
    player.on("exitfullscreen", function() {
      syncFullscreenButton();
      view.classList.remove("--native-fullscreen");
      coverSize.resume();
    });
    view.addEventListener("click", onClick);
    if (autoplay) autoplayScroll.setup();
  };
  this.__destruct = function() {
    view.removeEventListener("click", onClick);
    coverSize.destroy();
    autoplayScroll.destroy();
    if (player) {
      player.destroy();
      player = null;
    }
  };
  Site.ExtendClass(this);
};
